var getUrlParam = function (b) {
  var e,
    f,
    c = decodeURIComponent(window.location.search.substring(1)),
    d = c.split("&");
  for (f = 0; f < d.length; f++)
    if (((e = d[f].split("=")), e[0] === b)) return void 0 === e[1] || e[1];
};
function get_cookie(a) {
  a = a += "=";
  var b = document.cookie.indexOf(a);
  return b > -1
    ? ((b += a.length),
      (cookie_end = document.cookie.indexOf(";", b)),
      -1 == cookie_end && (cookie_end = document.cookie.length),
      unescape(document.cookie.substring(b, cookie_end)))
    : void 0;
}
function set_cookie(a, b, c) {
  c
    ? ((expire = new Date()),
      expire.setTime(expire.getTime() + 1e3 * c),
      (c = "; expires=" + expire.toGMTString()))
    : (c = "; expires=Wed, 1 Jan 2020 00:00:00 GMT;"),
    (document.cookie = a + "=" + escape(b) + c);
}
function showProductImage(a, b, c) {
  var d = screen.availWidth / 2 - 350,
    e = screen.availHeight / 2 - 300,
    f = "";
  ShowVariationThumb &&
    ((f = "&image_rule_id=" + encodeURIComponent(ShowVariationThumb)),
    (CurrentProdThumbImage = null)),
    (UrlAddOn = ""),
    c
      ? (UrlAddOn = "&current_image=" + c)
      : CurrentProdThumbImage &&
        (UrlAddOn = "&current_image=" + CurrentProdThumbImage);
  var g = window.open(
    a + "?product_id=" + b + f + UrlAddOn,
    "imagePop",
    "toolbar=0,scrollbars=1,location=0,statusbar=1,menubar=0,resizable=1,width=700,height=600,top=" +
      e +
      ",left=" +
      d
  );
  g.focus();
}
function CheckQuantityLimits(a) {
  var b = parseInt($("#qty_").val(), 10);
  return (
    b || (b = parseInt($("#quantity").val(), 10)),
    b < productMinQty
      ? (alert(lang.ProductMinQtyError), !1)
      : b > productMaxQty
      ? (alert(lang.ProductMaxQtyError), !1)
      : !0
  );
}
function CheckProductConfigurableFields(a) {
  var b = $(".FieldRequired"),
    c = !0;
  b.each(function () {
    var a = this.name.replace(/^.*\[/, ""),
      b = a.replace(/\].*$/, "");
    if ("checkbox" == this.type) {
      if (!this.checked)
        return (c = !1), alert(lang.EnterRequiredField), this.focus(), !1;
    } else if (
      "" == $.trim(this.value) &&
      ("file" != this.type ||
        ("file" == this.type &&
          "" == document.getElementById("CurrentProductFile_" + b).value))
    )
      return (c = !1), alert(lang.EnterRequiredField), this.focus(), !1;
  });
  var d = $(a).find("input[name^='ProductField']:file");
  return (
    d.each(function () {
      if ("" != this.value) {
        var a = this.name.replace(/^.*\[/, ""),
          b = a.replace(/\].*$/, ""),
          d = document.getElementById("ProductFileType_" + b).value;
        d = "," + d.replace(" ", "").toLowerCase() + ",";
        var e = this.value.replace(/^.*\./, "").toLowerCase();
        -1 == d.indexOf("," + e + ",") &&
          (alert(lang.InvalidFileTypeJS),
          this.focus(),
          this.select(),
          (c = !1));
      }
    }),
    c
  );
}
function check_add_to_cart(a, b) {
  var c = !0,
    d = $(a).find("input.qtyInput");
  if (
    (d.each(function () {
      return isNaN($(this).val()) || $(this).val() <= 0
        ? (alert(lang.InvalidQuantity),
          this.focus(),
          this.select(),
          (c = !1),
          !1)
        : void 0;
    }),
    0 == c)
  )
    return !1;
  if (!CheckProductConfigurableFields(a)) return !1;
  var e = $("#AddToCartForm").validate().form();
  if (!e) return !1;
  if (!CheckQuantityLimits(a)) return !1;
  if (b && !$(a).find(".CartVariationId").val()) {
    alert(lang.OptionMessage);
    var f = $(a).find("select").get(0);
    f && f.focus();
    var g = $(a).find("input[type=radio]").get(0);
    return g && g.focus(), !1;
  }
  return CheckEventDate() ? (config.FastCart ? fastCartAction() : !0) : !1;
}
function compareProducts(a) {
  var b = "";
  if ($("form").find("input[name=compare_product_ids]:checked").size() >= 2) {
    var c = document.getElementsByName("compare_product_ids");
    for (i = 0; i < c.length; i++) c[i].checked && (b = b + c[i].value + "/");
    return (b = b.replace(/\/$/, "")), (document.location.href = a + b), !1;
  }
  return alert(lang.CompareSelectMessage), !1;
}
function product_comparison_box_changed(a) {
  a
    ? num_products_to_compare++
    : 0 != num_products_to_compare && num_products_to_compare--;
}
function remove_product_from_comparison(a) {
  if (num_compare_items > 2) {
    for (i = 1; i < 11; i++)
      document.getElementById("compare_" + i + "_" + a).style.display = "none";
    num_compare_items--;
  } else alert(lang.CompareTwoProducts);
}
function show_product_review_form() {
  (document.getElementById("rating_box").style.display = ""),
    "undefined" != typeof HideProductTabs && 0 == HideProductTabs
      ? (CurrentProdTab = "ProductReviews_Tab")
      : (document.location.href = "#write_review"),
    $(".captchaPlaceholder").captchaPlaceholder();
}
function jump_to_product_reviews() {
  "undefined" != typeof HideProductTabs && 0 == HideProductTabs
    ? (CurrentProdTab = "ProductReviews_Tab")
    : (document.location.href = "#reviews");
}
function g(a) {
  return document.getElementById(a);
}
function check_product_review_form() {
  var a = g("revrating"),
    b = g("revtitle"),
    c = g("revtext"),
    d = (g("revfromname"), g("captcha")),
    e = g("email");
  return jQuery && jQuery(e).is(":visible") && "" == e.value
    ? (alert(lang.ReviewNoEmail), e.focus(), !1)
    : 0 == a.selectedIndex
    ? (alert(lang.ReviewNoRating), a.focus(), !1)
    : "" == b.value
    ? (alert(lang.ReviewNoTitle), b.focus(), !1)
    : "" == c.value
    ? (alert(lang.ReviewNoText), c.focus(), !1)
    : jQuery && jQuery(e).is(":visible") && "" == e.value
    ? (alert(lang.ReviewNoEmail), e.focus(), !1)
    : "" == d.value && "none" != HideReviewCaptcha
    ? (alert(lang.ReviewNoCaptcha), d.focus(), !1)
    : !0;
}
function check_small_search_form() {
  var a = g("search_query");
  return "" == a.value ? (alert(lang.EmptySmallSearch), a.focus(), !1) : !0;
}
function setCurrency(a) {
  var b = location.href;
  (b =
    "" !== location.search
      ? b.search(/[&|\?]setCurrencyId=[0-9]+/) > -1
        ? b.replace(/([&|\?]setCurrencyId=)[0-9]+/, "$1" + a)
        : b + "&setCurrencyId=" + a
      : b + "?setCurrencyId=" + a),
    (location.href = b);
}
function sel_panel(a) {}
function inline_add_to_cart(a, b, c, d) {
  if ("undefined" == typeof c) var c = "1";
  var e = '<form action="' + a + '/cart.php" method="post" id="inlineCartAdd">';
  if ("undefined" != typeof d && 1 == d) {
    var f = window.location;
    e += '<input type="hidden" name="returnUrl" value="' + escape(f) + '" />';
  }
  (e += '<input type="hidden" name="action" value="add" />'),
    (e += '<input type="hidden" name="qty" value="' + c + '" />'),
    (e += '<input type="hidden" name="product_id" value="' + b + '" />'),
    (e += "</form>"),
    $("body").append(e),
    $("#inlineCartAdd").submit();
}
function ShowPopupHelp(a, b, c) {
  var d = open("", "view", "height=450,width=550");
  c && (a = HtmlEntityDecode(a)), window.focus && d.focus();
  var e = d.document;
  return e.write(a), e.close(), !1;
}
function HtmlEntityDecode(a) {
  try {
    var b = document.createElement("textarea");
    return (b.innerHTML = a), b.value;
  } catch (c) {
    document.getElementById("htmlconverter").innerHTML =
      '<textarea id="innerConverter">' + a + "</textarea>";
    var d = document.getElementById("innerConverter").value;
    return (document.getElementById("htmlconverter").innerHTML = ""), d;
  }
}
function setProductThumbHeight() {
  var a = $(".ProductList:not(.List) .ProductImage a"),
    b = $(".ProductList:not(.List) li"),
    c = (b.height(), 2 * a.css("margin-left"), ThumbImageHeight);
  parseInt(a.css("padding-top"), 10) &&
    (c += 2 * parseInt(a.css("padding-top"), 10)),
    parseInt(a.css("margin-top"), 10) &&
      (c += 2 * parseInt(a.css("margin-top"), 10)),
    a.height(c),
    $.browser.msie &&
      $.browser.version >= 7 &&
      $.browser.version < 8 &&
      a.css("line-height", c + "px");
}
function getLang(a, b) {
  if (!lang[a]) return "";
  var c = lang[a];
  return "object" != typeof b
    ? c
    : ($.each(b, function (a, b) {
        c = c.replace(":" + a, b);
      }),
      c);
}
function ShowLoadingIndicator() {
  if (
    "undefined" == typeof disableLoadingIndicator ||
    !disableLoadingIndicator
  ) {
    var a;
    $(window).width();
    self.pageYOffset
      ? (a = self.pageYOffset)
      : document.documentElement && document.documentElement.scrollTop
      ? (a = document.documentElement.scrollTop)
      : document.body && (a = document.body.scrollTop),
      $("#AjaxLoading").show();
  }
}
function HideLoadingIndicator() {
  $("#AjaxLoading").hide();
}
function setProductListHeights(a, b) {
  function c(a) {
    var a = $(a),
      b = 0;
    a.css("min-height", "auto")
      .each(function () {
        $(this).height() > b && (b = $(this).height());
      })
      .css("min-height", b);
  }
  function d(a) {
    var b,
      d = $(a),
      e = {};
    d.each(function () {
      var a = $(this),
        b = a.offset().top;
      "undefined" == typeof e[b] ? (e[b] = a) : (e[b] = e[b].add(this));
    });
    for (b in e) Object.hasOwnProperty.call(e, b) && c(e[b]);
  }
  if ("undefined" == typeof DesignMode) {
    if ("undefined" != typeof a) {
      if ("undefined" != typeof loadedImages[a]) return;
      loadedImages[a] = !0;
    }
    setProductThumbHeight(),
      b || (b = ".Content"),
      d(b + " .ProductList:not(.List) li .ProductDetails"),
      "undefined" != typeof a &&
        d(
          b +
            " .ProductList:not(.List) li .ProductPriceRating:has(img[src$='" +
            a +
            "'])"
        ),
      d(b + " .ProductList:not(.List) li");
  }
}
function fastCartAction(a) {
  var b = "";
  if ("string" == typeof a) {
    var b = a;
    if (!b || -1 == b.indexOf("cart.php")) return !1;
    (b = b.replace(/^http[s]{0,1}:\/\/[^\/]*\/?/, "/")), (b += "&fastcart=1");
  }
  return !1;
}
function _showFastCart(a) {
  (a = $.extend(
    {
      closeTxt: !0,
      onShow: function () {
        $("#fastCartSuggestive a[href*='cart.php?action=add']").unbind("click");
        var a = $("#fastCartNumItemsTxt").html();
        a && $(".CartLink span").html("(" + a + ")"),
          setProductListHeights(null, ".fastCartContent");
      },
      onClose: function () {
        window.location.href.match(config.ShopPath + "/cart.php")
          ? ($("#ModalContainer").remove(),
            (window.location = window.location.href))
          : $("#ModalContainer").remove();
      },
    },
    a
  )),
    $.iModal.close(),
    $.iModal(a);
}
function isc_TrackSearchClick(a) {
  if (a) {
    $("#SearchTracker").remove();
    var b =
        "search.php?action=tracksearchclick&searchid=" +
        encodeURIComponent(a) +
        "&random=" +
        Math.random(),
      c = document.createElement("script");
    (c.type = "text/javascript"),
      (c.src = b),
      (c.id = "SearchTracker"),
      window.document.body.appendChild(c);
  }
}
function htmlspecialchars_decode(a, b) {
  var c = 0,
    d = 0,
    e = !1;
  "undefined" == typeof b && (b = 2),
    (a = a.toString().replace(/&lt;/g, "<").replace(/&gt;/g, ">"));
  var f = {
    ENT_NOQUOTES: 0,
    ENT_HTML_QUOTE_SINGLE: 1,
    ENT_HTML_QUOTE_DOUBLE: 2,
    ENT_COMPAT: 2,
    ENT_QUOTES: 3,
    ENT_IGNORE: 4,
  };
  if ((0 === b && (e = !0), "number" != typeof b)) {
    for (b = [].concat(b), d = 0; d < b.length; d++)
      0 === f[b[d]] ? (e = !0) : f[b[d]] && (c |= f[b[d]]);
    b = c;
  }
  return (
    b & f.ENT_HTML_QUOTE_SINGLE && (a = a.replace(/&#0*39;/g, "'")),
    e || (a = a.replace(/&quot;/g, '"')),
    (a = a.replace(/&amp;/g, "&"))
  );
}
function convertPriceStringToNumber(a) {
  return Number(a.replace(/[^0-9\.]+/g, ""));
}
function parseCsvIdsToNumericArray(a, b) {
  return a.split(b).map(Number);
}
function createCookie(a, b, c) {
  var d = "";
  if (c) {
    var e = new Date();
    e.setDate(e.getDate() + c), (d = "; expires=" + e.toGMTString());
  }
  document.cookie = a + "=" + b + d + "; path=/";
}
function switchSocialSharingTabs(a, b) {
  $(".sharingTab").removeClass("active"),
    $("." + a).addClass("active"),
    updateShareButton(a, b),
    updateSocialSharingPanel(b);
}
function activeSocialSharingServiceId() {
  return $(".sharingTab.active").attr("id").replace("tab", "");
}
function updateShareButton(a, b) {
  $(".js-share-button").attr("href", sharingData[b][a].sharingLink);
}
function initSocialSharingPanel(a) {
  var b = objectLength(sharingData),
    c = 0;
  $.each(sharingData, function (d, e) {
    var f = objectLength(e),
      g = 0;
    $.each(e, function (d, e) {
      g++,
        (e.imageElement = $("<img/>").attr("src", e.image).attr("alt", "")),
        g == f &&
          (c++,
          c == b && switchSocialSharingTabs(activeSocialSharingServiceId(), a));
    });
  });
}
function objectLength(a) {
  if ("object" != typeof a) return 0;
  var b = 0;
  for (i in a) a.hasOwnProperty(i) && b++;
  return b;
}
function updateSocialSharingPanel(a) {
  shareProductId = a;
  var b = activeSocialSharingServiceId();
  $("#tabcontent .photo").empty().append(sharingData[a][b].imageElement),
    $("#shareDescription").text(sharingData[a][b].description),
    updateShareButton(b, a),
    $("#shareText").text(sharingData[a][b].shareText),
    updateSharingDataChoices(a),
    $.iModal.close();
}
function updateSharingDataChoices(a) {
  $("#SharingDataChoices #productlist").empty(),
    $.each(sharingData, function (b, c) {
      if (b != a) {
        var d = $("<a/>").attr(
          "href",
          "javascript:updateSocialSharingPanel(" + b + ")"
        );
        d.append(c[activeSocialSharingServiceId()].imageElement);
        var e = $("<li/>").append(d);
        $("#SharingDataChoices #productlist").append(e);
      }
    });
}
function showProductChoices() {
  $.iModal({
    type: "inline",
    inline: "#ChooseAnotherProduct",
    width: 620,
    height: 200,
    title: getLang("ChooseAnotherProduct"),
  }),
    updateSharingDataChoices(shareProductId);
  var a = objectLength(sharingData),
    b = $("#SharingDataWrapper"),
    c = $("#SharingDataChoices");
  6 > a
    ? b.addClass("no-scroll")
    : c.jCarouselLite({
        btnNext: ".next",
        btnPrev: ".prev",
        visible: 4,
        scroll: 2,
        circular: !1,
        speed: 200,
      });
}
function triggerStorefrontEvent(a, b, c) {}
function ToggleShippingEstimation2() {
  var a = $(".EstimateShipping");
  $(".EstimatedShippingMethods").hide(),
    a.is(":hidden")
      ? ($(".EstimateShippingLink").hide(),
        a.slideDown(300, function () {}),
        $(".EstimateShipping select:eq(0)").focus(),
        $("#shippingZoneState").is(":hidden") &&
          $("#uniform-shippingZoneState").hide())
      : a.slideUp(300, function () {
          $(".EstimateShippingLink").show();
        });
}
function ModalBox(a, b) {
  var c =
    '<div class="ModalTitle">' +
    a +
    '</div><div class="ModalContent">' +
    b +
    '</div><div class="ModalButtonRow"></div>';
  $.iModal({ data: c });
}
function ModalBoxInline(a, b, c, d) {
  if ("undefined" == typeof c) var c = 800;
  if ("undefined" == typeof d) var d = !1;
  if (d)
    var e =
      '<div class="ModalTitle">' +
      a +
      '</div><div class="ModalContent">' +
      $(b).html() +
      '</div><div class="ModalButtonRow"></div>';
  else
    var e =
      '<div class="ModalTitle">' +
      a +
      '</div><div class="ModalContent">' +
      $(b).html() +
      '</div><div class="ModalButtonRow"><input type="button" class="CloseButton FormButton" value="Close Window" onclick="$.iModal.close();" /></div>';
  $.iModal({ data: e, width: c });
}
(window.Modernizr = (function (a, b, c) {
  function d(a) {
    s.cssText = a;
  }
  function e(a, b) {
    return typeof a === b;
  }
  function f(a, b) {
    return !!~("" + a).indexOf(b);
  }
  function g(a, b) {
    for (var d in a) {
      var e = a[d];
      if (!f(e, "-") && s[e] !== c) return "pfx" == b ? e : !0;
    }
    return !1;
  }
  function h(a, b, d) {
    for (var f in a) {
      var g = b[a[f]];
      if (g !== c)
        return d === !1 ? a[f] : e(g, "function") ? g.bind(d || b) : g;
    }
    return !1;
  }
  function i(a, b, c) {
    var d = a.charAt(0).toUpperCase() + a.slice(1),
      f = (a + " " + v.join(d + " ") + d).split(" ");
    return e(b, "string") || e(b, "undefined")
      ? g(f, b)
      : ((f = (a + " " + w.join(d + " ") + d).split(" ")), h(f, b, c));
  }
  var j,
    k,
    l,
    m = "2.8.3",
    n = {},
    o = !0,
    p = b.documentElement,
    q = "modernizr",
    r = b.createElement(q),
    s = r.style,
    t = ({}.toString, " -webkit- -moz- -o- -ms- ".split(" ")),
    u = "Webkit Moz O ms",
    v = u.split(" "),
    w = u.toLowerCase().split(" "),
    x = {},
    y = [],
    z = y.slice,
    A = function (a, c, d, e) {
      var f,
        g,
        h,
        i,
        j = b.createElement("div"),
        k = b.body,
        l = k || b.createElement("body");
      if (parseInt(d, 10))
        for (; d--; )
          (h = b.createElement("div")),
            (h.id = e ? e[d] : q + (d + 1)),
            j.appendChild(h);
      return (
        (f = ["&#173;", '<style id="s', q, '">', a, "</style>"].join("")),
        (j.id = q),
        ((k ? j : l).innerHTML += f),
        l.appendChild(j),
        k ||
          ((l.style.background = ""),
          (l.style.overflow = "hidden"),
          (i = p.style.overflow),
          (p.style.overflow = "hidden"),
          p.appendChild(l)),
        (g = c(j, a)),
        k
          ? j.parentNode.removeChild(j)
          : (l.parentNode.removeChild(l), (p.style.overflow = i)),
        !!g
      );
    },
    B = {}.hasOwnProperty;
  (l =
    e(B, "undefined") || e(B.call, "undefined")
      ? function (a, b) {
          return b in a && e(a.constructor.prototype[b], "undefined");
        }
      : function (a, b) {
          return B.call(a, b);
        }),
    Function.prototype.bind ||
      (Function.prototype.bind = function (a) {
        var b = this;
        if ("function" != typeof b) throw new TypeError();
        var c = z.call(arguments, 1),
          d = function () {
            if (this instanceof d) {
              var e = function () {};
              e.prototype = b.prototype;
              var f = new e(),
                g = b.apply(f, c.concat(z.call(arguments)));
              return Object(g) === g ? g : f;
            }
            return b.apply(a, c.concat(z.call(arguments)));
          };
        return d;
      }),
    (x.touch = function () {
      var c;
      return (
        "ontouchstart" in a || (a.DocumentTouch && b instanceof DocumentTouch)
          ? (c = !0)
          : A(
              [
                "@media (",
                t.join("touch-enabled),("),
                q,
                ")",
                "{#modernizr{top:9px;position:absolute}}",
              ].join(""),
              function (a) {
                c = 9 === a.offsetTop;
              }
            ),
        c
      );
    }),
    (x.csstransforms = function () {
      return !!i("transform");
    }),
    (x.csstransforms3d = function () {
      var a = !!i("perspective");
      return (
        a &&
          "webkitPerspective" in p.style &&
          A(
            "@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}",
            function (b, c) {
              a = 9 === b.offsetLeft && 3 === b.offsetHeight;
            }
          ),
        a
      );
    }),
    (x.fontface = function () {
      var a;
      return (
        A(
          '@font-face {font-family:"font"; src:url("https://")}',
          function (c, d) {
            var e = b.getElementById("smodernizr"),
              f = e.sheet || e.styleSheet,
              g = f
                ? f.cssRules && f.cssRules[0]
                  ? f.cssRules[0].cssText
                  : f.cssText || ""
                : "";
            a = /src/i.test(g) && 0 === g.indexOf(d.split(" ")[0]);
          }
        ),
        a
      );
    });
  for (var C in x)
    l(x, C) &&
      ((k = C.toLowerCase()), (n[k] = x[C]()), y.push((n[k] ? "" : "no-") + k));
  return (
    (n.addTest = function (a, b) {
      if ("object" == typeof a) for (var d in a) l(a, d) && n.addTest(d, a[d]);
      else {
        if (((a = a.toLowerCase()), n[a] !== c)) return n;
        (b = "function" == typeof b ? b() : b),
          "undefined" != typeof o &&
            o &&
            (p.className += " supports-" + (b ? "" : "no-") + a),
          (n[a] = b);
      }
      return n;
    }),
    d(""),
    (r = j = null),
    (n._version = m),
    (n._prefixes = t),
    (n._domPrefixes = w),
    (n._cssomPrefixes = v),
    (n.testProp = function (a) {
      return g([a]);
    }),
    (n.testAllProps = i),
    (n.testStyles = A),
    (p.className =
      p.className.replace(/(^|\s)no-js(\s|$)/, "$1$2") +
      (o ? " supports-js supports-" + y.join(" supports-") : "")),
    n
  );
})(this, this.document)),
  (function (a) {
    (a.flexslider = function (b, c) {
      var d = a(b);
      d.vars = a.extend({}, a.flexslider.defaults, c);
      var e,
        f = d.vars.namespace,
        g =
          window.navigator &&
          window.navigator.msPointerEnabled &&
          window.MSGesture,
        h =
          ("ontouchstart" in window ||
            g ||
            (window.DocumentTouch && document instanceof DocumentTouch)) &&
          d.vars.touch,
        i = "click touchend MSPointerUp",
        j = "",
        k = "vertical" === d.vars.direction,
        l = d.vars.reverse,
        m = d.vars.itemWidth > 0,
        n = "fade" === d.vars.animation,
        o = "" !== d.vars.asNavFor,
        p = {},
        q = !0;
      a.data(b, "flexslider", d),
        (p = {
          init: function () {
            (d.animating = !1),
              (d.currentSlide = parseInt(d.vars.startAt ? d.vars.startAt : 0)),
              isNaN(d.currentSlide) && (d.currentSlide = 0),
              (d.animatingTo = d.currentSlide),
              (d.atEnd = 0 === d.currentSlide || d.currentSlide === d.last),
              (d.containerSelector = d.vars.selector.substr(
                0,
                d.vars.selector.search(" ")
              )),
              (d.slides = a(d.vars.selector, d)),
              (d.container = a(d.containerSelector, d)),
              (d.count = d.slides.length),
              (d.syncExists = a(d.vars.sync).length > 0),
              "slide" === d.vars.animation && (d.vars.animation = "swing"),
              (d.prop = k ? "top" : "marginLeft"),
              (d.args = {}),
              (d.manualPause = !1),
              (d.stopped = !1),
              (d.started = !1),
              (d.startTimeout = null),
              (d.transitions =
                !d.vars.video &&
                !n &&
                d.vars.useCSS &&
                (function () {
                  var a = document.createElement("div"),
                    b = [
                      "perspectiveProperty",
                      "WebkitPerspective",
                      "MozPerspective",
                      "OPerspective",
                      "msPerspective",
                    ];
                  for (var c in b)
                    if (void 0 !== a.style[b[c]])
                      return (
                        (d.pfx = b[c].replace("Perspective", "").toLowerCase()),
                        (d.prop = "-" + d.pfx + "-transform"),
                        !0
                      );
                  return !1;
                })()),
              "" !== d.vars.controlsContainer &&
                (d.controlsContainer =
                  a(d.vars.controlsContainer).length > 0 &&
                  a(d.vars.controlsContainer)),
              "" !== d.vars.manualControls &&
                (d.manualControls =
                  a(d.vars.manualControls).length > 0 &&
                  a(d.vars.manualControls)),
              d.vars.randomize &&
                (d.slides.sort(function () {
                  return Math.round(Math.random()) - 0.5;
                }),
                d.container.empty().append(d.slides)),
              d.doMath(),
              d.setup("init"),
              d.vars.controlNav && p.controlNav.setup(),
              d.vars.directionNav && p.directionNav.setup(),
              d.vars.keyboard &&
                (1 === a(d.containerSelector).length ||
                  d.vars.multipleKeyboard) &&
                a(document).bind("keyup", function (a) {
                  var b = a.keyCode;
                  if (!d.animating && (39 === b || 37 === b)) {
                    var c =
                      39 === b
                        ? d.getTarget("next")
                        : 37 === b
                        ? d.getTarget("prev")
                        : !1;
                    d.flexAnimate(c, d.vars.pauseOnAction);
                  }
                }),
              d.vars.mousewheel &&
                d.bind("mousewheel", function (a, b, c, e) {
                  a.preventDefault();
                  var f = 0 > b ? d.getTarget("next") : d.getTarget("prev");
                  d.flexAnimate(f, d.vars.pauseOnAction);
                }),
              d.vars.pausePlay && p.pausePlay.setup(),
              d.vars.slideshow &&
                d.vars.pauseInvisible &&
                p.pauseInvisible.init(),
              d.vars.slideshow &&
                (d.vars.pauseOnHover &&
                  d.hover(
                    function () {
                      !d.manualPlay && !d.manualPause && d.pause();
                    },
                    function () {
                      !d.manualPause && !d.manualPlay && !d.stopped && d.play();
                    }
                  ),
                (d.vars.pauseInvisible && p.pauseInvisible.isHidden()) ||
                  (d.vars.initDelay > 0
                    ? (d.startTimeout = setTimeout(d.play, d.vars.initDelay))
                    : d.play())),
              o && p.asNav.setup(),
              h && d.vars.touch && p.touch(),
              (!n || (n && d.vars.smoothHeight)) &&
                a(window).bind("resize orientationchange focus", p.resize),
              d.find("img").attr("draggable", "false"),
              setTimeout(function () {
                d.vars.start(d);
              }, 200);
          },
          asNav: {
            setup: function () {
              (d.asNav = !0),
                (d.animatingTo = Math.floor(d.currentSlide / d.move)),
                (d.currentItem = d.currentSlide),
                d.slides
                  .removeClass(f + "active-slide")
                  .eq(d.currentItem)
                  .addClass(f + "active-slide"),
                g
                  ? ((b._slider = d),
                    d.slides.each(function () {
                      var b = this;
                      (b._gesture = new MSGesture()),
                        (b._gesture.target = b),
                        b.addEventListener(
                          "MSPointerDown",
                          function (a) {
                            a.preventDefault(),
                              a.currentTarget._gesture &&
                                a.currentTarget._gesture.addPointer(
                                  a.pointerId
                                );
                          },
                          !1
                        ),
                        b.addEventListener("MSGestureTap", function (b) {
                          b.preventDefault();
                          var c = a(this),
                            e = c.index();
                          a(d.vars.asNavFor).data("flexslider").animating ||
                            c.hasClass("active") ||
                            ((d.direction =
                              d.currentItem < e ? "next" : "prev"),
                            d.flexAnimate(e, d.vars.pauseOnAction, !1, !0, !0));
                        });
                    }))
                  : d.slides.click(function (b) {
                      b.preventDefault();
                      var c = a(this),
                        e = c.index(),
                        g = c.offset().left - a(d).scrollLeft();
                      0 >= g && c.hasClass(f + "active-slide")
                        ? d.flexAnimate(d.getTarget("prev"), !0)
                        : a(d.vars.asNavFor).data("flexslider").animating ||
                          c.hasClass(f + "active-slide") ||
                          ((d.direction = d.currentItem < e ? "next" : "prev"),
                          d.flexAnimate(e, d.vars.pauseOnAction, !1, !0, !0));
                    });
            },
          },
          controlNav: {
            setup: function () {
              d.manualControls
                ? p.controlNav.setupManual()
                : p.controlNav.setupPaging();
            },
            setupPaging: function () {
              var b,
                c,
                e =
                  "thumbnails" === d.vars.controlNav
                    ? "control-thumbs"
                    : "control-paging",
                g = 1;
              if (
                ((d.controlNavScaffold = a(
                  '<ol class="' + f + "control-nav " + f + e + '"></ol>'
                )),
                d.pagingCount > 1)
              )
                for (var h = 0; h < d.pagingCount; h++) {
                  if (
                    ((c = d.slides.eq(h)),
                    (b =
                      "thumbnails" === d.vars.controlNav
                        ? '<img src="' + c.attr("data-thumb") + '"/>'
                        : "<a>" + g + "</a>"),
                    "thumbnails" === d.vars.controlNav &&
                      !0 === d.vars.thumbCaptions)
                  ) {
                    var k = c.attr("data-thumbcaption");
                    "" != k &&
                      void 0 != k &&
                      (b += '<span class="' + f + 'caption">' + k + "</span>");
                  }
                  d.controlNavScaffold.append("<li>" + b + "</li>"), g++;
                }
              d.controlsContainer
                ? a(d.controlsContainer).append(d.controlNavScaffold)
                : d.append(d.controlNavScaffold),
                p.controlNav.set(),
                p.controlNav.active(),
                d.controlNavScaffold.delegate("a, img", i, function (b) {
                  if ((b.preventDefault(), "" === j || j === b.type)) {
                    var c = a(this),
                      e = d.controlNav.index(c);
                    c.hasClass(f + "active") ||
                      ((d.direction = e > d.currentSlide ? "next" : "prev"),
                      d.flexAnimate(e, d.vars.pauseOnAction));
                  }
                  "" === j && (j = b.type), p.setToClearWatchedEvent();
                });
            },
            setupManual: function () {
              (d.controlNav = d.manualControls),
                p.controlNav.active(),
                d.controlNav.bind(i, function (b) {
                  if ((b.preventDefault(), "" === j || j === b.type)) {
                    var c = a(this),
                      e = d.controlNav.index(c);
                    c.hasClass(f + "active") ||
                      (e > d.currentSlide
                        ? (d.direction = "next")
                        : (d.direction = "prev"),
                      d.flexAnimate(e, d.vars.pauseOnAction));
                  }
                  "" === j && (j = b.type), p.setToClearWatchedEvent();
                });
            },
            set: function () {
              var b = "thumbnails" === d.vars.controlNav ? "img" : "a";
              d.controlNav = a(
                "." + f + "control-nav li " + b,
                d.controlsContainer ? d.controlsContainer : d
              );
            },
            active: function () {
              d.controlNav
                .removeClass(f + "active")
                .eq(d.animatingTo)
                .addClass(f + "active");
            },
            update: function (b, c) {
              d.pagingCount > 1 && "add" === b
                ? d.controlNavScaffold.append(
                    a("<li><a>" + d.count + "</a></li>")
                  )
                : 1 === d.pagingCount
                ? d.controlNavScaffold.find("li").remove()
                : d.controlNav.eq(c).closest("li").remove(),
                p.controlNav.set(),
                d.pagingCount > 1 && d.pagingCount !== d.controlNav.length
                  ? d.update(c, b)
                  : p.controlNav.active();
            },
          },
          directionNav: {
            setup: function () {
              var b = a(
                '<ul class="' +
                  f +
                  'direction-nav"><li><a class="' +
                  f +
                  'prev" href="#">' +
                  d.vars.prevText +
                  '</a></li><li><a class="' +
                  f +
                  'next" href="#">' +
                  d.vars.nextText +
                  "</a></li></ul>"
              );
              d.controlsContainer
                ? (a(d.controlsContainer).append(b),
                  (d.directionNav = a(
                    "." + f + "direction-nav li a",
                    d.controlsContainer
                  )))
                : (d.append(b),
                  (d.directionNav = a("." + f + "direction-nav li a", d))),
                p.directionNav.update(),
                d.directionNav.bind(i, function (b) {
                  b.preventDefault();
                  var c;
                  ("" === j || j === b.type) &&
                    ((c = a(this).hasClass(f + "next")
                      ? d.getTarget("next")
                      : d.getTarget("prev")),
                    d.flexAnimate(c, d.vars.pauseOnAction)),
                    "" === j && (j = b.type),
                    p.setToClearWatchedEvent();
                });
            },
            update: function () {
              var a = f + "disabled";
              1 === d.pagingCount
                ? d.directionNav.addClass(a).attr("tabindex", "-1")
                : d.vars.animationLoop
                ? d.directionNav.removeClass(a).removeAttr("tabindex")
                : 0 === d.animatingTo
                ? d.directionNav
                    .removeClass(a)
                    .filter("." + f + "prev")
                    .addClass(a)
                    .attr("tabindex", "-1")
                : d.animatingTo === d.last
                ? d.directionNav
                    .removeClass(a)
                    .filter("." + f + "next")
                    .addClass(a)
                    .attr("tabindex", "-1")
                : d.directionNav.removeClass(a).removeAttr("tabindex");
            },
          },
          pausePlay: {
            setup: function () {
              var b = a('<div class="' + f + 'pauseplay"><a></a></div>');
              d.controlsContainer
                ? (d.controlsContainer.append(b),
                  (d.pausePlay = a(
                    "." + f + "pauseplay a",
                    d.controlsContainer
                  )))
                : (d.append(b), (d.pausePlay = a("." + f + "pauseplay a", d))),
                p.pausePlay.update(d.vars.slideshow ? f + "pause" : f + "play"),
                d.pausePlay.bind(i, function (b) {
                  b.preventDefault(),
                    ("" === j || j === b.type) &&
                      (a(this).hasClass(f + "pause")
                        ? ((d.manualPause = !0), (d.manualPlay = !1), d.pause())
                        : ((d.manualPause = !1),
                          (d.manualPlay = !0),
                          d.play())),
                    "" === j && (j = b.type),
                    p.setToClearWatchedEvent();
                });
            },
            update: function (a) {
              "play" === a
                ? d.pausePlay
                    .removeClass(f + "pause")
                    .addClass(f + "play")
                    .html(d.vars.playText)
                : d.pausePlay
                    .removeClass(f + "play")
                    .addClass(f + "pause")
                    .html(d.vars.pauseText);
            },
          },
          touch: function () {
            function a(a) {
              d.animating
                ? a.preventDefault()
                : (window.navigator.msPointerEnabled ||
                    1 === a.touches.length) &&
                  (d.pause(),
                  (q = k ? d.h : d.w),
                  (s = Number(new Date())),
                  (u = a.touches[0].pageX),
                  (v = a.touches[0].pageY),
                  (p =
                    m && l && d.animatingTo === d.last
                      ? 0
                      : m && l
                      ? d.limit -
                        (d.itemW + d.vars.itemMargin) * d.move * d.animatingTo
                      : m && d.currentSlide === d.last
                      ? d.limit
                      : m
                      ? (d.itemW + d.vars.itemMargin) * d.move * d.currentSlide
                      : l
                      ? (d.last - d.currentSlide + d.cloneOffset) * q
                      : (d.currentSlide + d.cloneOffset) * q),
                  (j = k ? v : u),
                  (o = k ? u : v),
                  b.addEventListener("touchmove", c, !1),
                  b.addEventListener("touchend", e, !1));
            }
            function c(a) {
              (u = a.touches[0].pageX),
                (v = a.touches[0].pageY),
                (r = k ? j - v : j - u),
                (t = k
                  ? Math.abs(r) < Math.abs(u - o)
                  : Math.abs(r) < Math.abs(v - o));
              var b = 500;
              (!t || Number(new Date()) - s > b) &&
                (a.preventDefault(),
                !n &&
                  d.transitions &&
                  (d.vars.animationLoop ||
                    (r /=
                      (0 === d.currentSlide && 0 > r) ||
                      (d.currentSlide === d.last && r > 0)
                        ? Math.abs(r) / q + 2
                        : 1),
                  d.setProps(p + r, "setTouch")));
            }
            function e(a) {
              if (
                (b.removeEventListener("touchmove", c, !1),
                d.animatingTo === d.currentSlide && !t && null !== r)
              ) {
                var f = l ? -r : r,
                  g = f > 0 ? d.getTarget("next") : d.getTarget("prev");
                d.canAdvance(g) &&
                ((Number(new Date()) - s < 550 && Math.abs(f) > 50) ||
                  Math.abs(f) > q / 2)
                  ? d.flexAnimate(g, d.vars.pauseOnAction)
                  : n ||
                    d.flexAnimate(d.currentSlide, d.vars.pauseOnAction, !0);
              }
              b.removeEventListener("touchend", e, !1),
                (j = null),
                (o = null),
                (r = null),
                (p = null);
            }
            function f(a) {
              a.stopPropagation(),
                d.animating
                  ? a.preventDefault()
                  : (d.pause(),
                    b._gesture.addPointer(a.pointerId),
                    (w = 0),
                    (q = k ? d.h : d.w),
                    (s = Number(new Date())),
                    (p =
                      m && l && d.animatingTo === d.last
                        ? 0
                        : m && l
                        ? d.limit -
                          (d.itemW + d.vars.itemMargin) * d.move * d.animatingTo
                        : m && d.currentSlide === d.last
                        ? d.limit
                        : m
                        ? (d.itemW + d.vars.itemMargin) *
                          d.move *
                          d.currentSlide
                        : l
                        ? (d.last - d.currentSlide + d.cloneOffset) * q
                        : (d.currentSlide + d.cloneOffset) * q));
            }
            function h(a) {
              a.stopPropagation();
              var c = a.target._slider;
              if (c) {
                var d = -a.translationX,
                  e = -a.translationY;
                return (
                  (w += k ? e : d),
                  (r = w),
                  (t = k
                    ? Math.abs(w) < Math.abs(-d)
                    : Math.abs(w) < Math.abs(-e)),
                  a.detail === a.MSGESTURE_FLAG_INERTIA
                    ? void setImmediate(function () {
                        b._gesture.stop();
                      })
                    : void (
                        (!t || Number(new Date()) - s > 500) &&
                        (a.preventDefault(),
                        !n &&
                          c.transitions &&
                          (c.vars.animationLoop ||
                            (r =
                              w /
                              ((0 === c.currentSlide && 0 > w) ||
                              (c.currentSlide === c.last && w > 0)
                                ? Math.abs(w) / q + 2
                                : 1)),
                          c.setProps(p + r, "setTouch")))
                      )
                );
              }
            }
            function i(a) {
              a.stopPropagation();
              var b = a.target._slider;
              if (b) {
                if (b.animatingTo === b.currentSlide && !t && null !== r) {
                  var c = l ? -r : r,
                    d = c > 0 ? b.getTarget("next") : b.getTarget("prev");
                  b.canAdvance(d) &&
                  ((Number(new Date()) - s < 550 && Math.abs(c) > 50) ||
                    Math.abs(c) > q / 2)
                    ? b.flexAnimate(d, b.vars.pauseOnAction)
                    : n ||
                      b.flexAnimate(b.currentSlide, b.vars.pauseOnAction, !0);
                }
                (j = null), (o = null), (r = null), (p = null), (w = 0);
              }
            }
            var j,
              o,
              p,
              q,
              r,
              s,
              t = !1,
              u = 0,
              v = 0,
              w = 0;
            g
              ? ((b.style.msTouchAction = "none"),
                (b._gesture = new MSGesture()),
                (b._gesture.target = b),
                b.addEventListener("MSPointerDown", f, !1),
                (b._slider = d),
                b.addEventListener("MSGestureChange", h, !1),
                b.addEventListener("MSGestureEnd", i, !1))
              : b.addEventListener("touchstart", a, !1);
          },
          resize: function () {
            !d.animating &&
              d.is(":visible") &&
              (m || d.doMath(),
              n
                ? p.smoothHeight()
                : m
                ? (d.slides.width(d.computedW),
                  d.update(d.pagingCount),
                  d.setProps())
                : k
                ? (d.viewport.height(d.h), d.setProps(d.h, "setTotal"))
                : (d.vars.smoothHeight && p.smoothHeight(),
                  d.newSlides.width(d.computedW),
                  d.setProps(d.computedW, "setTotal")));
          },
          smoothHeight: function (a) {
            if (!k || n) {
              var b = n ? d : d.viewport;
              a
                ? b.animate({ height: d.slides.eq(d.animatingTo).height() }, a)
                : b.height(d.slides.eq(d.animatingTo).height());
            }
          },
          sync: function (b) {
            var c = a(d.vars.sync).data("flexslider"),
              e = d.animatingTo;
            switch (b) {
              case "animate":
                c.flexAnimate(e, d.vars.pauseOnAction, !1, !0);
                break;
              case "play":
                !c.playing && !c.asNav && c.play();
                break;
              case "pause":
                c.pause();
            }
          },
          pauseInvisible: {
            visProp: null,
            init: function () {
              var a = ["webkit", "moz", "ms", "o"];
              if ("hidden" in document) return "hidden";
              for (var b = 0; b < a.length; b++)
                a[b] + "Hidden" in document &&
                  (p.pauseInvisible.visProp = a[b] + "Hidden");
              if (p.pauseInvisible.visProp) {
                var c =
                  p.pauseInvisible.visProp.replace(/[H|h]idden/, "") +
                  "visibilitychange";
                document.addEventListener(c, function () {
                  p.pauseInvisible.isHidden()
                    ? d.startTimeout
                      ? clearTimeout(d.startTimeout)
                      : d.pause()
                    : d.started
                    ? d.play()
                    : d.vars.initDelay > 0
                    ? setTimeout(d.play, d.vars.initDelay)
                    : d.play();
                });
              }
            },
            isHidden: function () {
              return document[p.pauseInvisible.visProp] || !1;
            },
          },
          setToClearWatchedEvent: function () {
            clearTimeout(e),
              (e = setTimeout(function () {
                j = "";
              }, 3e3));
          },
        }),
        (d.flexAnimate = function (b, c, e, g, i) {
          if (
            (!d.vars.animationLoop &&
              b !== d.currentSlide &&
              (d.direction = b > d.currentSlide ? "next" : "prev"),
            o &&
              1 === d.pagingCount &&
              (d.direction = d.currentItem < b ? "next" : "prev"),
            !d.animating && (d.canAdvance(b, i) || e) && d.is(":visible"))
          ) {
            if (o && g) {
              var j = a(d.vars.asNavFor).data("flexslider");
              if (
                ((d.atEnd = 0 === b || b === d.count - 1),
                j.flexAnimate(b, !0, !1, !0, i),
                (d.direction = d.currentItem < b ? "next" : "prev"),
                (j.direction = d.direction),
                Math.ceil((b + 1) / d.visible) - 1 === d.currentSlide ||
                  0 === b)
              )
                return (
                  (d.currentItem = b),
                  d.slides
                    .removeClass(f + "active-slide")
                    .eq(b)
                    .addClass(f + "active-slide"),
                  !1
                );
              (d.currentItem = b),
                d.slides
                  .removeClass(f + "active-slide")
                  .eq(b)
                  .addClass(f + "active-slide"),
                (b = Math.floor(b / d.visible));
            }
            if (
              ((d.animating = !0),
              (d.animatingTo = b),
              c && d.pause(),
              d.vars.before(d),
              d.syncExists && !i && p.sync("animate"),
              d.vars.controlNav && p.controlNav.active(),
              m ||
                d.slides
                  .removeClass(f + "active-slide")
                  .eq(b)
                  .addClass(f + "active-slide"),
              (d.atEnd = 0 === b || b === d.last),
              d.vars.directionNav && p.directionNav.update(),
              b === d.last &&
                (d.vars.end(d), d.vars.animationLoop || d.pause()),
              n)
            )
              h
                ? (d.slides.eq(d.currentSlide).css({ opacity: 0, zIndex: 1 }),
                  d.slides.eq(b).css({ opacity: 1, zIndex: 2 }),
                  d.wrapup(t))
                : (d.slides
                    .eq(d.currentSlide)
                    .css({ zIndex: 1 })
                    .animate(
                      { opacity: 0 },
                      d.vars.animationSpeed,
                      d.vars.easing
                    ),
                  d.slides
                    .eq(b)
                    .css({ zIndex: 2 })
                    .animate(
                      { opacity: 1 },
                      d.vars.animationSpeed,
                      d.vars.easing,
                      d.wrapup
                    ));
            else {
              var q,
                r,
                s,
                t = k ? d.slides.filter(":first").height() : d.computedW;
              m
                ? ((q = d.vars.itemMargin),
                  (s = (d.itemW + q) * d.move * d.animatingTo),
                  (r = s > d.limit && 1 !== d.visible ? d.limit : s))
                : (r =
                    0 === d.currentSlide &&
                    b === d.count - 1 &&
                    d.vars.animationLoop &&
                    "next" !== d.direction
                      ? l
                        ? (d.count + d.cloneOffset) * t
                        : 0
                      : d.currentSlide === d.last &&
                        0 === b &&
                        d.vars.animationLoop &&
                        "prev" !== d.direction
                      ? l
                        ? 0
                        : (d.count + 1) * t
                      : l
                      ? (d.count - 1 - b + d.cloneOffset) * t
                      : (b + d.cloneOffset) * t),
                d.setProps(r, "", d.vars.animationSpeed),
                d.transitions
                  ? ((d.vars.animationLoop && d.atEnd) ||
                      ((d.animating = !1), (d.currentSlide = d.animatingTo)),
                    d.container.unbind("webkitTransitionEnd transitionend"),
                    d.container.bind(
                      "webkitTransitionEnd transitionend",
                      function () {
                        d.wrapup(t);
                      }
                    ))
                  : d.container.animate(
                      d.args,
                      d.vars.animationSpeed,
                      d.vars.easing,
                      function () {
                        d.wrapup(t);
                      }
                    );
            }
            d.vars.smoothHeight && p.smoothHeight(d.vars.animationSpeed);
          }
        }),
        (d.wrapup = function (a) {
          !n &&
            !m &&
            (0 === d.currentSlide &&
            d.animatingTo === d.last &&
            d.vars.animationLoop
              ? d.setProps(a, "jumpEnd")
              : d.currentSlide === d.last &&
                0 === d.animatingTo &&
                d.vars.animationLoop &&
                d.setProps(a, "jumpStart")),
            (d.animating = !1),
            (d.currentSlide = d.animatingTo),
            d.vars.after(d);
        }),
        (d.animateSlides = function () {
          !d.animating && q && d.flexAnimate(d.getTarget("next"));
        }),
        (d.pause = function () {
          clearInterval(d.animatedSlides),
            (d.animatedSlides = null),
            (d.playing = !1),
            d.vars.pausePlay && p.pausePlay.update("play"),
            d.syncExists && p.sync("pause");
        }),
        (d.play = function () {
          d.playing && clearInterval(d.animatedSlides),
            (d.animatedSlides =
              d.animatedSlides ||
              setInterval(d.animateSlides, d.vars.slideshowSpeed)),
            (d.started = d.playing = !0),
            d.vars.pausePlay && p.pausePlay.update("pause"),
            d.syncExists && p.sync("play");
        }),
        (d.stop = function () {
          d.pause(), (d.stopped = !0);
        }),
        (d.canAdvance = function (a, b) {
          var c = o ? d.pagingCount - 1 : d.last;
          return b
            ? !0
            : o &&
              d.currentItem === d.count - 1 &&
              0 === a &&
              "prev" === d.direction
            ? !0
            : o &&
              0 === d.currentItem &&
              a === d.pagingCount - 1 &&
              "next" !== d.direction
            ? !1
            : a !== d.currentSlide || o
            ? d.vars.animationLoop
              ? !0
              : d.atEnd &&
                0 === d.currentSlide &&
                a === c &&
                "next" !== d.direction
              ? !1
              : d.atEnd &&
                d.currentSlide === c &&
                0 === a &&
                "next" === d.direction
              ? !1
              : !0
            : !1;
        }),
        (d.getTarget = function (a) {
          return (
            (d.direction = a),
            "next" === a
              ? d.currentSlide === d.last
                ? 0
                : d.currentSlide + 1
              : 0 === d.currentSlide
              ? d.last
              : d.currentSlide - 1
          );
        }),
        (d.setProps = function (a, b, c) {
          var e = (function () {
            var c = a
                ? a
                : (d.itemW + d.vars.itemMargin) * d.move * d.animatingTo,
              e = (function () {
                if (m)
                  return "setTouch" === b
                    ? a
                    : l && d.animatingTo === d.last
                    ? 0
                    : l
                    ? d.limit -
                      (d.itemW + d.vars.itemMargin) * d.move * d.animatingTo
                    : d.animatingTo === d.last
                    ? d.limit
                    : c;
                switch (b) {
                  case "setTotal":
                    return l
                      ? (d.count - 1 - d.currentSlide + d.cloneOffset) * a
                      : (d.currentSlide + d.cloneOffset) * a;
                  case "setTouch":
                    return l ? a : a;
                  case "jumpEnd":
                    return l ? a : d.count * a;
                  case "jumpStart":
                    return l ? d.count * a : a;
                  default:
                    return a;
                }
              })();
            return -1 * e + "px";
          })();
          d.transitions &&
            ((e = k
              ? "translate3d(0," + e + ",0)"
              : "translate3d(" + e + ",0,0)"),
            (c = void 0 !== c ? c / 1e3 + "s" : "0s"),
            d.container.css("-" + d.pfx + "-transition-duration", c)),
            (d.args[d.prop] = e),
            (d.transitions || void 0 === c) && d.container.css(d.args);
        }),
        (d.setup = function (b) {
          if (n)
            d.slides.css({
              width: "100%",
              float: "left",
              marginRight: "-100%",
              position: "relative",
            }),
              "init" === b &&
                (h
                  ? d.slides
                      .css({
                        opacity: 0,
                        display: "block",
                        webkitTransition:
                          "opacity " + d.vars.animationSpeed / 1e3 + "s ease",
                        zIndex: 1,
                      })
                      .eq(d.currentSlide)
                      .css({ opacity: 1, zIndex: 2 })
                  : d.slides
                      .css({ opacity: 0, display: "block", zIndex: 1 })
                      .eq(d.currentSlide)
                      .css({ zIndex: 2 })
                      .animate(
                        { opacity: 1 },
                        d.vars.animationSpeed,
                        d.vars.easing
                      )),
              d.vars.smoothHeight && p.smoothHeight();
          else {
            var c, e;
            "init" === b &&
              ((d.viewport = a('<div class="' + f + 'viewport"></div>')
                .css({ overflow: "hidden", position: "relative" })
                .appendTo(d)
                .append(d.container)),
              (d.cloneCount = 0),
              (d.cloneOffset = 0),
              l &&
                ((e = a.makeArray(d.slides).reverse()),
                (d.slides = a(e)),
                d.container.empty().append(d.slides))),
              d.vars.animationLoop &&
                !m &&
                ((d.cloneCount = 2),
                (d.cloneOffset = 1),
                "init" !== b && d.container.find(".clone").remove(),
                d.container
                  .append(
                    d.slides
                      .first()
                      .clone()
                      .addClass("clone")
                      .attr("aria-hidden", "true")
                  )
                  .prepend(
                    d.slides
                      .last()
                      .clone()
                      .addClass("clone")
                      .attr("aria-hidden", "true")
                  )),
              (d.newSlides = a(d.vars.selector, d)),
              (c = l
                ? d.count - 1 - d.currentSlide + d.cloneOffset
                : d.currentSlide + d.cloneOffset),
              k && !m
                ? (d.container
                    .height(200 * (d.count + d.cloneCount) + "%")
                    .css("position", "absolute")
                    .width("100%"),
                  setTimeout(
                    function () {
                      d.newSlides.css({ display: "block" }),
                        d.doMath(),
                        d.viewport.height(d.h),
                        d.setProps(c * d.h, "init");
                    },
                    "init" === b ? 100 : 0
                  ))
                : (d.container.width(200 * (d.count + d.cloneCount) + "%"),
                  d.setProps(c * d.computedW, "init"),
                  setTimeout(
                    function () {
                      d.doMath(),
                        d.newSlides.css({
                          width: d.computedW,
                          float: "left",
                          display: "block",
                        }),
                        d.vars.smoothHeight && p.smoothHeight();
                    },
                    "init" === b ? 100 : 0
                  ));
          }
          m ||
            d.slides
              .removeClass(f + "active-slide")
              .eq(d.currentSlide)
              .addClass(f + "active-slide");
        }),
        (d.doMath = function () {
          var a = d.slides.first(),
            b = d.vars.itemMargin,
            c = d.vars.minItems,
            e = d.vars.maxItems;
          (d.w = void 0 === d.viewport ? d.width() : d.viewport.width()),
            (d.h = a.height()),
            (d.boxPadding = a.outerWidth() - a.width()),
            m
              ? ((d.itemT = d.vars.itemWidth + b),
                (d.minW = c ? c * d.itemT : d.w),
                (d.maxW = e ? e * d.itemT - b : d.w),
                (d.itemW =
                  d.minW > d.w
                    ? (d.w - b * (c - 1)) / c
                    : d.maxW < d.w
                    ? (d.w - b * (e - 1)) / e
                    : d.vars.itemWidth > d.w
                    ? d.w
                    : d.vars.itemWidth),
                (d.visible = Math.floor(d.w / d.itemW)),
                (d.move =
                  d.vars.move > 0 && d.vars.move < d.visible
                    ? d.vars.move
                    : d.visible),
                (d.pagingCount = Math.ceil((d.count - d.visible) / d.move + 1)),
                (d.last = d.pagingCount - 1),
                (d.limit =
                  1 === d.pagingCount
                    ? 0
                    : d.vars.itemWidth > d.w
                    ? d.itemW * (d.count - 1) + b * (d.count - 1)
                    : (d.itemW + b) * d.count - d.w - b))
              : ((d.itemW = d.w),
                (d.pagingCount = d.count),
                (d.last = d.count - 1)),
            (d.computedW = d.itemW - d.boxPadding);
        }),
        (d.update = function (a, b) {
          d.doMath(),
            m ||
              (a < d.currentSlide
                ? (d.currentSlide += 1)
                : a <= d.currentSlide && 0 !== a && (d.currentSlide -= 1),
              (d.animatingTo = d.currentSlide)),
            d.vars.controlNav &&
              !d.manualControls &&
              (("add" === b && !m) || d.pagingCount > d.controlNav.length
                ? p.controlNav.update("add")
                : (("remove" === b && !m) ||
                    d.pagingCount < d.controlNav.length) &&
                  (m &&
                    d.currentSlide > d.last &&
                    ((d.currentSlide -= 1), (d.animatingTo -= 1)),
                  p.controlNav.update("remove", d.last))),
            d.vars.directionNav && p.directionNav.update();
        }),
        (d.addSlide = function (b, c) {
          var e = a(b);
          (d.count += 1),
            (d.last = d.count - 1),
            k && l
              ? void 0 !== c
                ? d.slides.eq(d.count - c).after(e)
                : d.container.prepend(e)
              : void 0 !== c
              ? d.slides.eq(c).before(e)
              : d.container.append(e),
            d.update(c, "add"),
            (d.slides = a(d.vars.selector + ":not(.clone)", d)),
            d.setup(),
            d.vars.added(d);
        }),
        (d.removeSlide = function (b) {
          var c = isNaN(b) ? d.slides.index(a(b)) : b;
          (d.count -= 1),
            (d.last = d.count - 1),
            isNaN(b)
              ? a(b, d.slides).remove()
              : k && l
              ? d.slides.eq(d.last).remove()
              : d.slides.eq(b).remove(),
            d.doMath(),
            d.update(c, "remove"),
            (d.slides = a(d.vars.selector + ":not(.clone)", d)),
            d.setup(),
            d.vars.removed(d);
        }),
        p.init();
    }),
      a(window)
        .blur(function (a) {
          focused = !1;
        })
        .focus(function (a) {
          focused = !0;
        }),
      (a.flexslider.defaults = {
        namespace: "flex-",
        selector: ".slides > li",
        animation: "fade",
        easing: "swing",
        direction: "horizontal",
        reverse: !1,
        animationLoop: !0,
        smoothHeight: !1,
        startAt: 0,
        slideshow: !0,
        slideshowSpeed: 7e3,
        animationSpeed: 600,
        initDelay: 0,
        randomize: !1,
        thumbCaptions: !1,
        pauseOnAction: !0,
        pauseOnHover: !1,
        pauseInvisible: !0,
        useCSS: !0,
        touch: !0,
        video: !1,
        controlNav: !0,
        directionNav: !0,
        prevText: "Previous",
        nextText: "Next",
        keyboard: !0,
        multipleKeyboard: !1,
        mousewheel: !1,
        pausePlay: !1,
        pauseText: "Pause",
        playText: "Play",
        controlsContainer: "",
        manualControls: "",
        sync: "",
        asNavFor: "",
        itemWidth: 0,
        itemMargin: 0,
        minItems: 1,
        maxItems: 0,
        move: 0,
        allowOneSlide: !0,
        start: function () {},
        before: function () {},
        after: function () {},
        end: function () {},
        added: function () {},
        removed: function () {},
      }),
      (a.fn.flexslider = function (b) {
        if ((void 0 === b && (b = {}), "object" == typeof b))
          return this.each(function () {
            var c = a(this),
              d = b.selector ? b.selector : ".slides > li",
              e = c.find(d);
            (1 === e.length && b.allowOneSlide === !0) || 0 === e.length
              ? (e.fadeIn(400), b.start && b.start(c))
              : void 0 === c.data("flexslider") && new a.flexslider(this, b);
          });
        var c = a(this).data("flexslider");
        switch (b) {
          case "play":
            c.play();
            break;
          case "pause":
            c.pause();
            break;
          case "stop":
            c.stop();
            break;
          case "next":
            c.flexAnimate(c.getTarget("next"), !0);
            break;
          case "prev":
          case "previous":
            c.flexAnimate(c.getTarget("prev"), !0);
            break;
          default:
            "number" == typeof b && c.flexAnimate(b, !0);
        }
      });
  })(jQuery),
  (function (a) {
    if ("function" == typeof define && define.amd) define(a);
    else if ("object" == typeof exports) module.exports = a();
    else {
      var b = window.Cookies,
        c = (window.Cookies = a());
      c.noConflict = function () {
        return (window.Cookies = b), c;
      };
    }
  })(function () {
    function a() {
      for (var a = 0, b = {}; a < arguments.length; a++) {
        var c = arguments[a];
        for (var d in c) b[d] = c[d];
      }
      return b;
    }
    function b(c) {
      function d(b, e, f) {
        var g;
        if (arguments.length > 1) {
          if (
            ((f = a({ path: "/" }, d.defaults, f)),
            "number" == typeof f.expires)
          ) {
            var h = new Date();
            h.setMilliseconds(h.getMilliseconds() + 864e5 * f.expires),
              (f.expires = h);
          }
          try {
            (g = JSON.stringify(e)), /^[\{\[]/.test(g) && (e = g);
          } catch (i) {}
          return (
            (e = c.write
              ? c.write(e, b)
              : encodeURIComponent(String(e)).replace(
                  /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                  decodeURIComponent
                )),
            (b = encodeURIComponent(String(b))),
            (b = b.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)),
            (b = b.replace(/[\(\)]/g, escape)),
            (document.cookie = [
              b,
              "=",
              e,
              f.expires && "; expires=" + f.expires.toUTCString(),
              f.path && "; path=" + f.path,
              f.domain && "; domain=" + f.domain,
              f.secure ? "; secure" : "",
            ].join(""))
          );
        }
        b || (g = {});
        for (
          var j = document.cookie ? document.cookie.split("; ") : [],
            k = /(%[0-9A-Z]{2})+/g,
            l = 0;
          l < j.length;
          l++
        ) {
          var m = j[l].split("="),
            n = m[0].replace(k, decodeURIComponent),
            o = m.slice(1).join("=");
          '"' === o.charAt(0) && (o = o.slice(1, -1));
          try {
            if (
              ((o = c.read
                ? c.read(o, n)
                : c(o, n) || o.replace(k, decodeURIComponent)),
              this.json)
            )
              try {
                o = JSON.parse(o);
              } catch (i) {}
            if (b === n) {
              g = o;
              break;
            }
            b || (g[n] = o);
          } catch (i) {}
        }
        return g;
      }
      return (
        (d.get = d.set = d),
        (d.getJSON = function () {
          return d.apply({ json: !0 }, [].slice.call(arguments));
        }),
        (d.defaults = {}),
        (d.remove = function (b, c) {
          d(b, "", a(c, { expires: -1 }));
        }),
        (d.withConverter = b),
        d
      );
    }
    return b(function () {});
  }),
  (function (a, b, c) {
    function d(a) {
      var b = {},
        d = /^jQuery\d+$/;
      return (
        c.each(a.attributes, function (a, c) {
          c.specified && !d.test(c.name) && (b[c.name] = c.value);
        }),
        b
      );
    }
    function e(a, d) {
      var e = this,
        f = c(e);
      if (e.value == f.attr("placeholder") && f.hasClass("placeholder"))
        if (f.data("placeholder-password")) {
          if (
            ((f = f
              .hide()
              .next()
              .show()
              .attr("id", f.removeAttr("id").data("placeholder-id"))),
            a === !0)
          )
            return (f[0].value = d);
          f.focus();
        } else
          (e.value = ""),
            f.removeClass("placeholder"),
            e == b.activeElement && e.select();
    }
    function f() {
      var a,
        b = this,
        f = c(b),
        g = this.id;
      if ("" == b.value) {
        if ("password" == b.type) {
          if (!f.data("placeholder-textinput")) {
            try {
              a = f.clone().attr({ type: "text" });
            } catch (h) {
              a = c("<input>").attr(c.extend(d(this), { type: "text" }));
            }
            a
              .removeAttr("name")
              .data({ "placeholder-password": f, "placeholder-id": g })
              .bind("focus.placeholder", e),
              f
                .data({ "placeholder-textinput": a, "placeholder-id": g })
                .before(a);
          }
          f = f.removeAttr("id").hide().prev().attr("id", g).show();
        }
        f.addClass("placeholder"), (f[0].value = f.attr("placeholder"));
      } else f.removeClass("placeholder");
    }
    var g,
      h,
      i = "placeholder" in b.createElement("input"),
      j = "placeholder" in b.createElement("textarea"),
      k = c.fn,
      l = c.valHooks,
      m = c.propHooks;
    i && j
      ? ((h = k.placeholder =
          function () {
            return this;
          }),
        (h.input = h.textarea = !0))
      : ((h = k.placeholder =
          function () {
            var a = this;
            return (
              a
                .filter((i ? "textarea" : ":input") + "[placeholder]")
                .not(".placeholder")
                .bind({ "focus.placeholder": e, "blur.placeholder": f })
                .data("placeholder-enabled", !0)
                .trigger("blur.placeholder"),
              a
            );
          }),
        (h.input = i),
        (h.textarea = j),
        (g = {
          get: function (a) {
            var b = c(a),
              d = b.data("placeholder-password");
            return d
              ? d[0].value
              : b.data("placeholder-enabled") && b.hasClass("placeholder")
              ? ""
              : a.value;
          },
          set: function (a, d) {
            var g = c(a),
              h = g.data("placeholder-password");
            return h
              ? (h[0].value = d)
              : g.data("placeholder-enabled")
              ? ("" == d
                  ? ((a.value = d), a != b.activeElement && f.call(a))
                  : g.hasClass("placeholder")
                  ? e.call(a, !0, d) || (a.value = d)
                  : (a.value = d),
                g)
              : (a.value = d);
          },
        }),
        i || ((l.input = g), (m.value = g)),
        j || ((l.textarea = g), (m.value = g)),
        c(function () {
          c(b).delegate("form", "submit.placeholder", function () {
            var a = c(".placeholder", this).each(e);
            setTimeout(function () {
              a.each(f);
            }, 10);
          });
        }),
        c(a).bind("beforeunload.placeholder", function () {
          c(".placeholder").each(function () {
            this.value = "";
          });
        }));
  })(this, document, jQuery),
  $(window).load(function () {
    if ($("body").hasClass("landing-page")) {
      var a = $("#main-header-landing-page"),
        b = $(".navigation-landing-page"),
        c = b.offset().top,
        d = a.outerHeight(),
        e = $(".under-header-section").outerHeight();
      $(window)
        .on("scroll", function () {
          var f = $(window).scrollTop();
          f >= e
            ? a.add(".landing-page #page").addClass("sticky")
            : a.add(".landing-page #page").removeClass("sticky"),
            f >= c - d ? b.addClass("sticky") : b.removeClass("sticky");
        })
        .trigger("scroll");
    }
    $(".navigation-landing-page ul li a").click(function (a) {
      var b = $($(this).attr("href"));
      b.length &&
        ($("body, html").animate({ scrollTop: b.offset().top - 100 }, 250),
        a.preventDefault());
    });
  }),
  $(function () {
    $("[placeholder]").placeholder(),
      $("#tino-landing-page-slider").flexslider({
        directionNav: !0,
        controlNav: !0,
        useCSS: !1,
        animation: "slide",
        controlsContainer: "#tino-landing-page-slider .pagination",
      }),
      $("#first-product-slider").flexslider({
        animation: "slide",
        controlNav: !1,
        directionNav: !1,
        animationLoop: !1,
        slideshow: !1,
        sync: "#first-product-carousel",
      }),
      $("#first-product-carousel").flexslider({
        animation: "slide",
        controlNav: !1,
        directionNav: !1,
        animationLoop: !1,
        slideshow: !1,
        itemWidth: 100,
        itemMargin: 5,
        asNavFor: "#first-product-slider",
      }),
      $("#home-slider").flexslider({
        directionNav: !0,
        controlNav: !0,
        useCSS: !1,
        animation: "slide",
        controlsContainer: "#home-slider .pagination",
      }),
      $("#home-slider2").flexslider({
        directionNav: !0,
        controlNav: !0,
        useCSS: !1,
        animation: "slide",
        controlsContainer: "#home-slider2 .pagination",
      }),
      $("#recipe-slider").flexslider({
        directionNav: 1,
        controlNav: 0,
        useCSS: !1,
        animation: "slide",
        animationLoop: true,
        itemWidth: 170,
        maxItems: 5,
        controlsContainer: "#recipe-slider .pagination",
      }),
      $("#tabs").tabs({
        active: 1,
        hide: "fade",
        show: { effect: "fade", duration: 250 },
      }),
      $(".spinner").spinner({ min: 1 });
    var a, b, c, d;
    $(".rate-stars .star").hover(
      function () {
        (a = $(this).parent().find(".star")),
          (b = $(this).parent().find(".star").length - 1),
          (c = $(this).index()),
          (d = $(this)
            .parent()
            .find(".star")
            .slice(0, c + 1)),
          d.addClass("active");
      },
      function () {
        d.removeClass("active");
      }
    ),
      $(".rate-stars .star").click(function () {
        a.removeClass("on"),
          d.addClass("on"),
          $(this).parent().find(".user-rating").val(d.length);
      });
  }),
  $(function () {
    $("html").addClass("javascript");
  });
var num_products_to_compare = 0,
  product_option_value = "",
  CurrentProdTab = "";
if (
  ((function (a) {
    a.fn.captchaPlaceholder = function () {
      return (
        a(this).each(function () {
          var b = a(this);
          if (b.parent().is(":visible")) {
            var c = b.find(".captchaImage");
            if (!c.length) {
              var d = Math.round(500 + 7500 * Math.random());
              (c = a(
                '<img class="captchaImage" src="' +
                  config.ShopPath +
                  "/captcha.php?" +
                  d +
                  '" />'
              )),
                b.append(c);
            }
          }
        }),
        this
      );
    };
  })(jQuery),
  "undefined" == typeof lang && (lang = {}),
  document.all)
) {
  var isIE7 = !1;
  0 == isIE7 &&
    $(document).ready(function () {
      $(".ProductList li").hover(
        function () {
          $(this).addClass("Over");
        },
        function () {
          $(this).removeClass("Over");
        }
      ),
        $(".ComparisonTable tr").hover(
          function () {
            $(this).addClass("Over");
          },
          function () {
            $(this).removeClass("Over");
          }
        );
    }),
    $(".ProductList li:last-child").addClass("LastChild");
}
var loadedImages = {};
$(document).ready(function () {
  $(".Rating img").length > 0
    ? $(".Rating img").each(function () {
        return 0 != $(this).height()
          ? (setProductListHeights(), !1)
          : void $(this).load(function () {
              var a = $(this).attr("src").split("/"),
                b = a.length - 1;
              setProductListHeights(a[b]);
            });
      })
    : setProductListHeights(),
    $(".InitialFocus").focus(),
    $("table.Stylize tr:first-child").addClass("First"),
    $("table.Stylize tr:last-child").addClass("Last"),
    $("table.Stylize tr td:odd").addClass("Odd"),
    $("table.Stylize tr td:even").addClass("Even"),
    $("table.Stylize tr:even").addClass("Odd"),
    $("table.Stylize tr:even").addClass("Even"),
    $(".TabContainer .TabNav li").click(function () {
      return (
        $(this).parent(".TabNav").find("li").removeClass("Active"),
        $(this).parents(".TabContainer").find(".TabContent").hide(),
        $(this).addClass("Active"),
        $(this)
          .parents(".TabContainer")
          .find("#TabContent" + this.id)
          .show(),
        $(this).find("a").blur(),
        !1
      );
    }),
    $("html").ajaxStart(function () {
      ShowLoadingIndicator();
    }),
    $("html").ajaxComplete(function () {
      HideLoadingIndicator();
    }),
    $(".CheckboxTogglesOtherElements")
      .on("change", function (a) {
        if (this.id) {
          var b = "ShowIf_" + this.id + "_Checked",
            c = $("." + b);
          if (this.checked) return void c.show();
          var d = /^ShowIf_(.+)_Checked$/;
          c.each(function () {
            var a = $(this),
              c = a.attr("class").split(/\s+/),
              e = !1;
            $.each(c, function (a, c) {
              if (c !== b) {
                var f = d.exec(c);
                if (null !== f) {
                  var g = f[1];
                  return $("#" + g).attr("checked") ? ((e = !0), !1) : void 0;
                }
              }
            }),
              e || a.hide();
          });
        }
      })
      .change();
});
var config = {};
"undefined" == typeof Date.prototype.setISO &&
  (Date.prototype.setISO = function (a) {
    var b = a.split("-");
    this.setFullYear(b[0], b[1] - 1, b[2]);
  }),
  $('form[action$="process_payment"]').on("submit", function (a) {
    if (!a.isDefaultPrevented()) {
      var b = this.onsubmit;
      if (b && 0 == b()) return void a.preventDefault();
      var c = this,
        d = function () {
          $('input[type="submit"]', c)
            .val("Processing Your Order...")
            .attr("disabled", "disabled");
        };
      $.browser.opera ? d() : setTimeout(d, 1);
    }
  }),
  $("#OrderConfirmationForm").on("submit", function (a) {
    if (!a.isDefaultPrevented()) {
      var b = this.onsubmit;
      if (b && 0 == b()) return void a.preventDefault();
      var c = this,
        d = function () {
          $("#bottom_payment_button", c).attr("disabled", "disabled");
        };
      $.browser.opera ? d() : setTimeout(d, 1);
    }
  }),
  (function (a) {
    "undefined" != typeof a && a.ajaxSetup({ cache: !0 });
  })($),
  (jQuery.fn.autobox = function (a) {
    var b = $.extend({ defaultClass: "default", filledClass: "filled" }, a);
    return this.each(function () {
      var a = $(this),
        c = a.val();
      if ((a.addClass(b.defaultClass), "password" == a.attr("type"))) {
        var d = $(
          '<input type="text" class="' +
            b.defaultClass +
            '"value="' +
            a.val() +
            '" />'
        );
        d.css({
          position: "absolute",
          "z-index": 10,
          top: a.position().top + "px",
          left: a.position().left + "px",
        }),
          $(window).resize(function () {
            d.css({
              top: a.position().top + "px",
              left: a.position().left + "px",
            });
          }),
          d.bind("focus", function () {
            var b = $(this);
            b.hide(), a.show(), a.css({ visibility: "visible" }), a.focus();
          }),
          a.before(d);
      }
      a.bind("focus", function () {
        var a = $(this);
        a.removeClass(b.defaultClass),
          a.addClass(b.filledClass),
          a.val() == c && a.val("");
      }),
        a.bind("blur", function () {
          var a = $(this);
          "" == a.val()
            ? (a.val(c),
              a.addClass(b.defaultClass),
              a.removeClass(b.filledClass),
              "password" == a.attr("type") && d.show())
            : a.addClass(b.filledClass);
        });
    });
  }),
  $(document).ready(function () {
    if (
      ($(".autobox").autobox(),
      $("#prodAccordion .prodAccordionContent").hide(),
      $("#prodAccordion .ProductDescription").addClass("current"),
      $("#prodAccordion .ProductDescriptionContainer").show(),
      $("#prodAccordion .Block .subtitle").click(function () {
        return (
          $(this).parent().toggleClass("current"),
          $(this).css("outline", "none").siblings("div").slideToggle("slow"),
          !1
        );
      }),
      document.all &&
        $("#SideCategoryList li").hover(
          function () {
            return $(this).addClass("over"), !1;
          },
          function () {
            $(this).removeClass("over");
          }
        ),
      $.browser.msie && 7 == parseInt($.browser.version))
    ) {
      var a = 1e3;
      $("#Menu ul li").each(function () {
        $(this).css("z-index", a), (a -= 10);
      }),
        $("#HeaderLower ul li").each(function () {
          $(this).css("z-index", a), (a -= 10);
        });
    }
    if ($.browser.msie && 6 == parseInt($.browser.version)) {
      var a = 1e3;
      $("#Menu ul li").each(function () {
        $(this).css("z-index", a), (a -= 10);
      }),
        $("#HeaderLower ul li").each(function () {
          $(this).css("z-index", a), (a -= 10);
        });
    }
    $("#change-currency").click(function (a) {
      a.stopPropagation(),
        $("#currency-chooser .currencies").toggle(),
        $(window).one("click", function () {
          $("#currency-chooser .currencies").hide();
        });
    });
  }),
  (function (a, b) {
    "use strict";
    function c(a) {
      var b = Array.prototype.slice.call(arguments, 1);
      return a.prop ? a.prop.apply(a, b) : a.attr.apply(a, b);
    }
    function d(a, b, c) {
      var d, e;
      for (d in c)
        c.hasOwnProperty(d) &&
          ((e = d.replace(/ |$/g, b.eventNamespace)), a.bind(d, c[d]));
    }
    function e(a, b, c) {
      d(a, c, {
        focus: function () {
          b.addClass(c.focusClass);
        },
        blur: function () {
          b.removeClass(c.focusClass), b.removeClass(c.activeClass);
        },
        mouseenter: function () {
          b.addClass(c.hoverClass);
        },
        mouseleave: function () {
          b.removeClass(c.hoverClass), b.removeClass(c.activeClass);
        },
        "mousedown touchbegin": function () {
          a.is(":disabled") || b.addClass(c.activeClass);
        },
        "mouseup touchend": function () {
          b.removeClass(c.activeClass);
        },
      });
    }
    function f(a, b) {
      a.removeClass(b.hoverClass + " " + b.focusClass + " " + b.activeClass);
    }
    function g(a, b, c) {
      c ? a.addClass(b) : a.removeClass(b);
    }
    function h(a, b, c) {
      var d = "checked",
        e = b.is(":" + d);
      b.prop ? b.prop(d, e) : e ? b.attr(d, d) : b.removeAttr(d),
        g(a, c.checkedClass, e);
    }
    function i(a, b, c) {
      g(a, c.disabledClass, b.is(":disabled"));
    }
    function j(a, b, c) {
      switch (c) {
        case "after":
          return a.after(b), a.next();
        case "before":
          return a.before(b), a.prev();
        case "wrap":
          return a.wrap(b), a.parent();
      }
      return null;
    }
    function k(b, d, e) {
      var f, g, h;
      return (
        e || (e = {}),
        (e = a.extend(
          {
            bind: {},
            divClass: null,
            divWrap: "wrap",
            spanClass: null,
            spanHtml: null,
            spanWrap: "wrap",
          },
          e
        )),
        (f = a("<div />")),
        (g = a("<span />")),
        d.autoHide &&
          b.is(":hidden") &&
          "none" === b.css("display") &&
          f.hide(),
        e.divClass && f.addClass(e.divClass),
        e.spanClass && g.addClass(e.spanClass),
        (h = c(b, "id")),
        d.useID && h && c(f, "id", d.idPrefix + "-" + h),
        e.spanHtml && g.html(e.spanHtml),
        (f = j(b, f, e.divWrap)),
        (g = j(b, g, e.spanWrap)),
        i(f, b, d),
        { div: f, span: g }
      );
    }
    function l() {
      var b, c, d, e;
      return (
        (e = "rgb(120,2,153)"),
        (c = a('<div style="width:0;height:0;color:' + e + '">')),
        a("body").append(c),
        (d = c.get(0)),
        (b = window.getComputedStyle
          ? window.getComputedStyle(d, "").color
          : (d.currentStyle || d.style || {}).color),
        c.remove(),
        b.replace(/ /g, "") !== e
      );
    }
    function m(b) {
      return b ? a("<span />").text(b).html() : "";
    }
    function n(a) {
      var b;
      return a[0].multiple ? !0 : ((b = c(a, "size")), !b || 1 >= b ? !1 : !0);
    }
    function o() {
      return !1;
    }
    function p(a, b) {
      var c = "none";
      d(a, b, { "selectstart dragstart mousedown": o }),
        a.css({
          MozUserSelect: c,
          msUserSelect: c,
          webkitUserSelect: c,
          userSelect: c,
        });
    }
    function q(a, b, c) {
      var d = a.val();
      "" === d
        ? (d = c.fileDefaultHtml)
        : ((d = d.split(/[\/\\]+/)), (d = d[d.length - 1])),
        b.text(d);
    }
    function r(a, b, c) {
      var d, e;
      for (
        d = [],
          a.each(function () {
            var a;
            for (a in b)
              Object.prototype.hasOwnProperty.call(b, a) &&
                (d.push({ el: this, name: a, old: this.style[a] }),
                (this.style[a] = b[a]));
          }),
          c();
        d.length;

      )
        (e = d.pop()), (e.el.style[e.name] = e.old);
    }
    function s(a, b) {
      r(
        a.parents().andSelf().not(":visible"),
        { visibility: "hidden", display: "block", position: "absolute" },
        b
      );
    }
    function t(a, b) {
      return function () {
        a.unwrap().unwrap().unbind(b.eventNamespace);
      };
    }
    var u = !0,
      v = !1,
      w = [
        {
          match: function (a) {
            return a.is("a, button, :submit, :reset, input[type='button']");
          },
          apply: function (a, b) {
            var g, h, j, l, n;
            return (
              (h = b.submitDefaultHtml),
              a.is(":reset") && (h = b.resetDefaultHtml),
              (l = a.is("a, button")
                ? function () {
                    return a.html() || h;
                  }
                : function () {
                    return m(c(a, "value")) || h;
                  }),
              (j = k(a, b, { divClass: b.buttonClass, spanHtml: l() })),
              (g = j.div),
              e(a, g, b),
              (n = !1),
              d(g, b, {
                "click touchend": function () {
                  var b, d, e, f;
                  n ||
                    ((n = !0),
                    a[0].dispatchEvent
                      ? ((b = document.createEvent("MouseEvents")),
                        b.initEvent("click", !0, !0),
                        (d = a[0].dispatchEvent(b)),
                        (jQuery.browser.msie || jQuery.browser.mozilla) &&
                          a.is("a") &&
                          d &&
                          ((e = c(a, "target")),
                          (f = c(a, "href")),
                          e && "_self" !== e
                            ? window.open(f, e)
                            : (document.location.href = f)))
                      : a.click(),
                    (n = !1));
                },
              }),
              p(g, b),
              {
                remove: function () {
                  return g.after(a), g.remove(), a.unbind(b.eventNamespace), a;
                },
                update: function () {
                  f(g, b), i(g, a, b), j.span.html(l());
                },
              }
            );
          },
        },
        {
          match: function (a) {
            return a.is(":checkbox");
          },
          apply: function (a, b) {
            var c, g, j;
            return (
              (c = k(a, b, { divClass: b.checkboxClass })),
              (g = c.div),
              (j = c.span),
              e(a, g, b),
              d(a, b, {
                "click touchend": function () {
                  h(j, a, b);
                },
              }),
              h(j, a, b),
              {
                remove: t(a, b),
                update: function () {
                  f(g, b),
                    j.removeClass(b.checkedClass),
                    h(j, a, b),
                    i(g, a, b);
                },
              }
            );
          },
        },
        {
          match: function (a) {
            return a.is(":file");
          },
          apply: function (b, g) {
            function h() {
              q(b, n, g);
            }
            var l, m, n, o;
            return (
              (l = k(b, g, {
                divClass: g.fileClass,
                spanClass: g.fileButtonClass,
                spanHtml: g.fileButtonHtml,
                spanWrap: "after",
              })),
              (m = l.div),
              (o = l.span),
              (n = a("<span />").html(g.fileDefaultHtml)),
              n.addClass(g.filenameClass),
              (n = j(b, n, "after")),
              c(b, "size") || c(b, "size", m.width() / 10),
              e(b, m, g),
              h(),
              a.browser.msie
                ? d(b, g, {
                    click: function () {
                      b.trigger("change"), setTimeout(h, 0);
                    },
                  })
                : d(b, g, { change: h }),
              p(n, g),
              p(o, g),
              {
                remove: function () {
                  return (
                    n.remove(), o.remove(), b.unwrap().unbind(g.eventNamespace)
                  );
                },
                update: function () {
                  f(m, g), q(b, n, g), i(m, b, g);
                },
              }
            );
          },
        },
        {
          match: function (a) {
            if (a.is("input")) {
              var b = (" " + c(a, "type") + " ").toLowerCase(),
                d =
                  " color date datetime datetime-local email month number password search tel text time url week ";
              return d.indexOf(b) >= 0;
            }
            return !1;
          },
          apply: function (a) {
            var b = c(a, "type");
            return (
              a.addClass(b),
              {
                remove: function () {
                  a.removeClass(b);
                },
                update: o,
              }
            );
          },
        },
        {
          match: function (a) {
            return a.is(":radio");
          },
          apply: function (b, g) {
            var j, l, m;
            return (
              (j = k(b, g, { divClass: g.radioClass })),
              (l = j.div),
              (m = j.span),
              e(b, l, g),
              d(b, g, {
                "click touchend": function () {
                  a.uniform.update(a(':radio[name="' + c(b, "name") + '"]'));
                },
              }),
              h(m, b, g),
              {
                remove: t(b, g),
                update: function () {
                  f(l, g), h(m, b, g), i(l, b, g);
                },
              }
            );
          },
        },
        {
          match: function (a) {
            return a.is("select") && !n(a) ? !0 : !1;
          },
          apply: function (b, c) {
            var g, h, j, l;
            return (
              c.selectAutoWidth &&
                s(b, function () {
                  l = b.width();
                }),
              (g = k(b, c, {
                divClass: c.selectClass,
                spanHtml: (
                  b.find(":selected:first") || b.find("option:first")
                ).html(),
                spanWrap: "before",
              })),
              (h = g.div),
              (j = g.span),
              c.selectAutoWidth
                ? s(b, function () {
                    var a;
                    (a = j.outerWidth() - j.width()), h.width(l);
                  })
                : h.addClass("fixedWidth"),
              e(b, h, c),
              d(b, c, {
                change: function () {
                  j.html(b.find(":selected").html()),
                    h.removeClass(c.activeClass);
                },
                "click touchend": function () {
                  var a = b.find(":selected").html();
                  j.html() !== a && b.trigger("change");
                },
                keyup: function () {
                  j.html(b.find(":selected").html());
                },
              }),
              p(j, c),
              {
                remove: function () {
                  return j.remove(), b.unwrap().unbind(c.eventNamespace), b;
                },
                update: function () {
                  c.selectAutoWidth
                    ? (a.uniform.restore(b), b.uniform(c))
                    : (f(h, c), j.html(b.find(":selected").html()), i(h, b, c));
                },
              }
            );
          },
        },
        {
          match: function (a) {
            return a.is("select") && n(a) ? !0 : !1;
          },
          apply: function (a, b) {
            return (
              a.addClass(b.selectMultiClass),
              {
                remove: function () {
                  a.removeClass(b.selectMultiClass);
                },
                update: o,
              }
            );
          },
        },
        {
          match: function (a) {
            return a.is("textarea");
          },
          apply: function (a, b) {
            return (
              a.addClass(b.textareaClass),
              {
                remove: function () {
                  a.removeClass(b.textareaClass);
                },
                update: o,
              }
            );
          },
        },
      ];
    a.browser.msie && a.browser.version < 7 && (u = !1),
      (a.uniform = {
        defaults: {
          activeClass: "active",
          autoHide: !0,
          buttonClass: "button",
          checkboxClass: "checker",
          checkedClass: "checked",
          disabledClass: "disabled",
          eventNamespace: ".uniform",
          fileButtonClass: "action",
          fileButtonHtml: "Choose File",
          fileClass: "uploader",
          fileDefaultHtml: "No file selected",
          filenameClass: "filename",
          focusClass: "focus",
          hoverClass: "hover",
          idPrefix: "uniform",
          radioClass: "radio",
          resetDefaultHtml: "Reset",
          resetSelector: !1,
          selectAutoWidth: !0,
          selectClass: "selector",
          selectMultiClass: "uniform-multiselect",
          submitDefaultHtml: "Submit",
          textareaClass: "uniform",
          useID: !0,
        },
        elements: [],
      }),
      (a.fn.uniform = function (b) {
        var c = this;
        return (
          (b = a.extend({}, a.uniform.defaults, b)),
          v || ((v = !0), l() && (u = !1)),
          u
            ? (b.resetSelector &&
                a(b.resetSelector).mouseup(function () {
                  window.setTimeout(function () {
                    a.uniform.update(c);
                  }, 10);
                }),
              this.each(function () {
                var c,
                  d,
                  e,
                  f = a(this);
                if (f.data("uniformed")) return void a.uniform.update(f);
                for (c = 0; c < w.length; c += 1)
                  if (((d = w[c]), d.match(f, b)))
                    return (
                      (e = d.apply(f, b)),
                      f.data("uniformed", e),
                      void a.uniform.elements.push(f.get(0))
                    );
              }))
            : this
        );
      }),
      (a.uniform.restore = a.fn.uniform.restore =
        function (c) {
          c === b && (c = a.uniform.elements),
            a(c).each(function () {
              var b,
                c,
                d = a(this);
              (c = d.data("uniformed")),
                c &&
                  (c.remove(),
                  (b = a.inArray(this, a.uniform.elements)),
                  b >= 0 && a.uniform.elements.splice(b, 1),
                  d.removeData("uniformed"));
            });
        }),
      (a.uniform.update = a.fn.uniform.update =
        function (c) {
          c === b && (c = a.uniform.elements),
            a(c).each(function () {
              var b,
                c = a(this);
              (b = c.data("uniformed")), b && b.update(c, b.options);
            });
        });
  })(jQuery),
  $(document).ready(function () {
    var a = $(".cartCount strong").text(),
      b = $(".cartCost strong").text();
    0 != b.length && $(".CartLink span").html(a + " Items / " + b);
    var c = window.location.hash;
    ("#ProductReviews" == c || "#write_review" == c) &&
      $("#ProductReviews").find(".subtitle").trigger("click"),
      $(".wishTrigger").click(function () {
        $("#frmWishList").submit();
      }),
      $(
        "input[type=text],input[type=url],input[type=email],input[type=password]"
      )
        .focus(function () {
          $(this).val() == $(this).attr("title") && $(this).val("");
        })
        .blur(function () {
          "" == $(this).val() && $(this).val($(this).attr("title"));
        }),
      $(".SubTotal td strong:contains('Grand Total:')")
        .closest("tr")
        .addClass("gtotal");
    var d = $(".ProductDetailsGrid .DetailRow.PriceRow .Value em");
    d.children("strike").length > 0 && d.addClass("on-sale");
    var e = config.ShopPath,
      f = window.location.pathname,
      g = f.toLowerCase().replace(e, "");
    $(".Breadcrumb ul").last().addClass("last");
    var h;
    $("#Menu .category-list").addClass("page"),
      $("#SideCategoryList li a").each(function () {
        var a = $(this).attr("href").toLowerCase().replace(e, "");
        g == a && $(this).closest(".parent").children("a").addClass("active");
      }),
      $(".category-list.page a").each(function () {
        var a = $(this).attr("href").toLowerCase().replace(e, "");
        g == a && $(this).closest(".parent").addClass("ActivePage"),
          h == a && $(this).closest(".parent").addClass("ActivePage");
      }),
      $('input[type="checkbox"]').is(":visible") &&
        $('input[type="checkbox"]')
          .not('#category input[type="checkbox"]')
          .uniform(),
      $('input[type="radio"]').is(":visible") &&
        $('input[type="radio"]')
          .not(
            '.productOptionPickListSwatch input[type="radio"], .productOptionViewRectangle input[type="radio"]'
          )
          .uniform(),
      $('input[type="file"]').uniform();
    var i = $(".CurrencyList").find(".Sel").html();
    $(".selected-currency").html(i),
      $("#wishlistsform a:contains('Share')").each(function () {
        $(this).attr("title", "Share Wishlist");
      }),
      $("#selectAllWishLists").click(function () {
        $.uniform.update();
      }),
      $("#Menu ul > li").each(function () {
        $(this).addClass("parent");
      }),
      $(".PageMenu .category-list  > li").each(function () {
        $(this).addClass("parent"),
          (tallest = 0),
          (group = $(this).find("ul")),
          group.each(function () {
            (thisHeight = $(this).height()),
              thisHeight > tallest && (tallest = thisHeight);
          }),
          group.height(tallest);
      }),
      $(".PageMenu li").each(function () {
        0 != $(this).children("ul").size() &&
          $(this).children("a").addClass("hasSub");
      }),
      $(".PageMenu li").hover(
        function () {
          return $(this).addClass("over"), !1;
        },
        function () {
          $(this).removeClass("over");
        }
      );
    var j = $(".PageMenu .parent").size();
    if (
      ($(".category-list .parent").each(function (a) {
        $(this).css("z-index", j - a);
      }),
      $(".PageMenu #Menu .parent").each(function (a) {
        $(this).css("z-index", j - a);
      }),
      (menuToggle = $("#ToggleMenu")),
      (drawer = $("#DrawerMenu")),
      (page = $(".page")),
      menuToggle.click(function () {
        page.hasClass("off-screen")
          ? setTimeout(function () {
              drawer.toggleClass("on-screen");
            }, 100)
          : drawer.toggleClass("on-screen"),
          page.toggleClass("off-screen");
      }),
      $(".CartLink a span").length > 0)
    ) {
      var k = $(".CartLink a span")
        .html()
        .replace(/[^\d.]/g, "");
      $("#cart-amount .total").html(k);
    }
    var l = "ontouchstart" in window || navigator.msMaxTouchPoints > 0;
    if (
      (l && ($.fn.productOptionPreviewDisplay = $.noop),
      matchMedia("screen and (max-width: 480px)").matches)
    ) {
      searchbar = $(".header-secondary").parents("#Header");
      var m = 0;
      $(window).scroll(function () {
        var a = $(this).scrollTop();
        a > m && a > 0
          ? searchbar.addClass("off-screen")
          : searchbar.removeClass("off-screen"),
          (m = a);
      }),
        ($.fn.fitText = function (a, b) {
          var c = a || 1,
            d = $.extend(
              {
                minFontSize: Number.NEGATIVE_INFINITY,
                maxFontSize: Number.POSITIVE_INFINITY,
              },
              b
            );
          return this.each(function () {
            var a = $(this),
              b = function () {
                var b = a.text().length;
                a.css(
                  "font-size",
                  Math.max(
                    Math.min((a.width() / b) * c, parseFloat(d.maxFontSize)),
                    parseFloat(d.minFontSize)
                  )
                );
              };
            b(), $(window).bind("resize.fittext orientationchange.fittext", b);
          });
        }),
        $("#LogoContainer h1").fitText(1.6, {
          minFontSize: "14px",
          maxFontSize: "28px",
        });
    }
    $(".FormFieldLabel").each(function () {
      $(this).text($(this).text().replace(/:/g, ""));
    });
  }),
  !(function (a) {
    (a.iModal = function (b) {
      return a.iModal.modal.init(b);
    }),
      (a.modal = function () {}),
      (a.modal.close = function () {
        return a.iModal.modal.close(!0);
      }),
      (a.iModal.close = function () {
        return a.iModal.modal.close(!0);
      }),
      (a.fn.iModal = function (b) {
        return (
          (b = a.extend({}, { type: "inline", inline: a(this).html() }, b)),
          a.iModal.modal.init(b)
        );
      }),
      (a.iModal.defaults = {
        overlay: 40,
        overlayCss: {},
        containerCss: {},
        close: !0,
        closeTitle: "Close",
        closeTxt: !1,
        onOpen: null,
        onShow: null,
        onClose: null,
        onBeforeClose: null,
        onAjaxError: null,
        type: "string",
        width: "630",
        height: "auto",
        buttons: "",
        title: "",
        method: "get",
        top: "15%",
        scrollable: !0,
      }),
      (a.iModal.modal = {
        options: null,
        init: function (b) {
          return a("#ModalContentContainer").length > 0
            ? this
            : ((this.options = a.extend({}, a.iModal.defaults, b)),
              "inline" == this.options.type &&
                ((this.options.data = a(this.options.inline).html()),
                a(this.options.inline).html("")),
              this.generateModal(),
              this);
        },
        checkHeight: function () {
          var b, c, d;
          setTimeout(function () {
            if (
              ((b = a(window).height()),
              (c = a("#ModalContentContainer").height()),
              (d =
                a("#ModalContent").height() ||
                a.iModal.modal.options.contentHeight),
              c > 0.85 * b ||
                (a.iModal.modal.options.scrollable &&
                  0.85 * b < a.iModal.modal.options.height))
            ) {
              var e = c - d;
              a("#ModalContent").css({
                overflow: "auto",
                height: 0.75 * (c - e) + "px",
              }),
                a("#ModalContainer").css({
                  height: 0.8 * b + "px",
                  bottom: 0,
                  "overflow-y": "scroll",
                }),
                a(".ModalButtonRow").css("padding-right", "30px");
            }
          }, 1);
        },
        ajaxError: function (b, c, d) {
          this.hideLoader(),
            a.isFunction(this.options.onAjaxError) &&
              this.options.onAjaxError.apply(this, [b, c, d]);
        },
        createFrame: function (b, c) {
          var d = a("<iframe />")
              .width("100%")
              .attr("frameBorder", "0")
              .appendTo(b)[0],
            e = d.contentWindow ? d.contentWindow.document : d.contentDocument;
          e.open(),
            e.write(c),
            e.close(),
            a(e).ready(function () {
              var b = e.body.scrollHeight + 20;
              a(d).height(b);
            });
        },
        displayModal: function (b) {
          "object" == typeof b && "string" == typeof b.imodal && (b = b.imodal),
            this.hideLoader(),
            (modalContent = ""),
            (!a.browser.msie || a.browser.version >= 7) &&
              (modalContent =
                '<div id="ModalTopLeftCorner"></div><div id="ModalTopBorder"></div><div id="ModalTopRightCorner"></div><div id="ModalLeftBorder"></div><div id="ModalRightBorder"></div><div id="ModalBottomLeftCorner"></div><div id="ModalBottomRightCorner"></div><div id="ModalBottomBorder"></div>'),
            b.indexOf("ModalTitle") > 0 && b.indexOf("ModalContent") > 0
              ? (modalContent +=
                  '<div id="ModalContentContainer">' + b + "</div>")
              : ((buttons = ""),
                this.options.buttons &&
                  (buttons =
                    '<div class="ModalButtonRow">' +
                    this.options.buttons +
                    "</div>"),
                (modalContent +=
                  '<div id="ModalContentContainer"><div class="ModalTitle">' +
                  this.options.title +
                  '</div><div class="ModalContent">' +
                  b +
                  "</div>" +
                  buttons +
                  "</div>")),
            (cssProperties = {
              position: "fixed",
              zIndex: 3100,
              width: this.options.width + "px",
              height: this.options.height + "px",
            }),
            a.browser.msie &&
              a.browser.version < 7 &&
              (cssProperties.position = "absolute"),
            a.browser.msie &&
            a.browser.version <= 7 &&
            "rtl" == a("body").css("direction")
              ? (cssProperties.marginRight = this.options.width / 2 + "px")
              : (cssProperties.marginLeft =
                  "-" + this.options.width / 2 + "px"),
            (cssProperties.top = this.options.top);
          var c = a("<div>")
            .attr("id", "ModalContainer")
            .addClass("modalContainer")
            .css(cssProperties)
            .hide()
            .appendTo("body")
            .html('<div class="modalData">' + modalContent + "</div>");
          if (
            (this.options.className && c.addClass(this.options.className),
            a("#ModalContainer").find(".ModalButtonRow, #ModalButtonRow")
              .length > 0 &&
              a("#ModalContainer").addClass("ModalContentWithButtons"),
            this.options.close &&
              ((modal = this),
              a("<a/>")
                .addClass("modalClose")
                .attr("title", this.options.closeTitle)
                .appendTo("#ModalContainer")
                .click(function (a) {
                  a.preventDefault(), modal.close();
                }),
              a(document).bind("keypress", function (b) {
                27 == b.keyCode && a("#ModalContainer .modalClose").click();
              }),
              this.options.closeTxt &&
                (a("#ModalContainer .modalClose")
                  .html(this.options.closeTitle)
                  .css("backgroundPosition", "65px 0")
                  .css("lineHeight", "15px")
                  .css("textDecoration", "none")
                  .css("width", "60px")
                  .css("paddingRight", "20px")
                  .css("textAlign", "right"),
                a("#ModalContainer .ModalTitle")
                  .css("borderBottom", "medium none")
                  .css("backgroundColor", "#fff"),
                a("#ModalContainer #ModalTopBorder").css(
                  "backgroundImage",
                  "none"
                ))),
            a.isFunction(this.options.onOpen)
              ? this.options.onOpen.apply(this)
              : (a("#ModalContainer").show(),
                a.isFunction(this.options.onShow) &&
                  this.options.onShow.apply(this)),
            this.options.scrollable)
          ) {
            var d = a("#ModalContent");
            d.css("overflow", "auto"),
              a(".ModalButtonRow").css("padding-top", "10px"),
              this.checkHeight();
          }
          a(window).resize(this.checkHeight).scroll(this.checkHeight);
        },
        showLoader: function () {
          a("<div/>").attr("id", "ModalLoadingIndicator").appendTo("body");
        },
        showOverlayLoader: function () {
          a("<div/>")
            .attr("id", "ModalOverlay")
            .addClass("modalOverlay")
            .css({
              opacity: 0.4,
              height: "100%",
              width: "100%",
              position: "fixed",
              left: 0,
              top: 0,
              zIndex: 3e3,
            })
            .appendTo("body"),
            a("<div/>").attr("id", "ModalLoadingIndicator").appendTo("body");
        },
        hideOverlayLoader: function () {
          a("#ModalLoadingIndicator").remove(), a(".modalOverlay").remove();
        },
        hideLoader: function () {
          a("#ModalLoadingIndicator").remove();
        },
        generateModal: function () {
          if (
            (a("<div/>")
              .attr("id", "ModalOverlay")
              .addClass("modalOverlay")
              .css({
                opacity: this.options.overlay / 100,
                height: "100%",
                width: "100%",
                position: "fixed",
                left: 0,
                top: 0,
                zIndex: 3e3,
              })
              .appendTo("body"),
            a.browser.msie &&
              a.browser.version < 7 &&
              ((wHeight = a(document.body).height() + "px"),
              (wWidth = a(document.body).width() + "px"),
              a("#ModalOverlay").css({
                position: "absolute",
                height: wHeight,
                width: wWidth,
              }),
              a("<iframe/>")
                .attr("src", "javascript:false;")
                .attr("id", "ModalTempiFrame")
                .css({
                  opacity: 0,
                  position: "absolute",
                  width: wWidth,
                  height: wHeight,
                  zIndex: 1e3,
                  top: 0,
                  left: 0,
                })
                .appendTo("body")),
            this.showLoader(),
            "ajax" == this.options.type)
          ) {
            (modal = this),
              (data = {}),
              void 0 != this.options.urlData && (data = this.options.urlData);
            var b = "get";
            this.options.method && (b = this.options.method),
              a.ajax({
                url: this.options.url,
                type: b,
                success: function (a) {
                  modal.displayModal(a);
                },
                error: function (a, b, c) {
                  modal.ajaxError(a, b, c);
                },
                data: data,
                type: this.options.method,
                global: !1,
              });
          } else if ("iframe" == this.options.type) {
            (modal = this),
              (data = {}),
              void 0 != this.options.urlData && (data = this.options.urlData);
            var b = "get";
            this.options.method && (b = this.options.method),
              a.ajax({
                url: this.options.url,
                type: b,
                success: function (b) {
                  modal.displayModal(""),
                    modal.createFrame(
                      a("#ModalContentContainer .ModalContent"),
                      b
                    );
                },
                error: function (a, b, c) {
                  modal.ajaxError(a, b, c);
                },
                data: data,
                type: this.options.method,
                global: !1,
              });
          } else this.displayModal(this.options.data);
        },
        close: function (b) {
          if (this.options) {
            if (a.isFunction(this.options.onBeforeClose)) {
              if (this.options.onBeforeClose.apply(this, []) === !1) return;
              this.options.onBeforeClose = null;
            }
            "inline" == this.options.type &&
              a(this.options.inline).html(this.options.data),
              a.isFunction(this.options.onClose) && !b
                ? this.options.onClose.apply(this)
                : a("#ModalContainer").remove(),
              a("#ModalLoadingIndicator").remove(),
              a("#ModalOverlay").remove(),
              a("#ModalTempiFrame").remove();
          }
        },
      });
  })(jQuery),
  (function (a) {
    a.extend(a.fn, {
      validate: function (b) {
        if (!this.length)
          return void (
            b &&
            b.debug &&
            window.console &&
            console.warn("nothing selected, can't validate, returning nothing")
          );
        var c = a.data(this[0], "validator");
        return c
          ? c
          : ((c = new a.validator(b, this[0])),
            a.data(this[0], "validator", c),
            c.settings.onsubmit &&
              (this.find("input, button")
                .filter(".cancel")
                .click(function () {
                  c.cancelSubmit = !0;
                }),
              c.settings.submitHandler &&
                this.find("input, button")
                  .filter(":submit")
                  .click(function () {
                    c.submitButton = this;
                  }),
              this.submit(function (b) {
                function d() {
                  if (c.settings.submitHandler) {
                    if (c.submitButton)
                      var b = a("<input type='hidden'/>")
                        .attr("name", c.submitButton.name)
                        .val(c.submitButton.value)
                        .appendTo(c.currentForm);
                    return (
                      c.settings.submitHandler.call(c, c.currentForm),
                      c.submitButton && b.remove(),
                      !1
                    );
                  }
                  return !0;
                }
                return (
                  c.settings.debug && b.preventDefault(),
                  c.cancelSubmit
                    ? ((c.cancelSubmit = !1), d())
                    : c.form()
                    ? c.pendingRequest
                      ? ((c.formSubmitted = !0), !1)
                      : d()
                    : (c.focusInvalid(), !1)
                );
              })),
            c);
      },
      valid: function () {
        if (a(this[0]).is("form")) return this.validate().form();
        var b = !0,
          c = a(this[0].form).validate();
        return (
          this.each(function () {
            b &= c.element(this);
          }),
          b
        );
      },
      removeAttrs: function (b) {
        var c = {},
          d = this;
        return (
          a.each(b.split(/\s/), function (a, b) {
            (c[b] = d.attr(b)), d.removeAttr(b);
          }),
          c
        );
      },
      rules: function (b, c) {
        var d = this[0];
        if (b) {
          var e = a.data(d.form, "validator").settings,
            f = e.rules,
            g = a.validator.staticRules(d);
          switch (b) {
            case "add":
              a.extend(g, a.validator.normalizeRule(c)),
                (f[d.name] = g),
                c.messages &&
                  (e.messages[d.name] = a.extend(
                    e.messages[d.name],
                    c.messages
                  ));
              break;
            case "remove":
              if (!c) return delete f[d.name], g;
              var h = {};
              return (
                a.each(c.split(/\s/), function (a, b) {
                  (h[b] = g[b]), delete g[b];
                }),
                h
              );
          }
        }
        var i = a.validator.normalizeRules(
          a.extend(
            {},
            a.validator.metadataRules(d),
            a.validator.classRules(d),
            a.validator.attributeRules(d),
            a.validator.staticRules(d)
          ),
          d
        );
        if (i.required) {
          var j = i.required;
          delete i.required, (i = a.extend({ required: j }, i));
        }
        return i;
      },
    }),
      a.extend(a.expr[":"], {
        blank: function (b) {
          return !a.trim("" + b.value);
        },
        filled: function (b) {
          return !!a.trim("" + b.value);
        },
        unchecked: function (a) {
          return !a.checked;
        },
      }),
      (a.validator = function (b, c) {
        (this.settings = a.extend(!0, {}, a.validator.defaults, b)),
          (this.currentForm = c),
          this.init();
      }),
      (a.validator.format = function (b, c) {
        return 1 == arguments.length
          ? function () {
              var c = a.makeArray(arguments);
              return c.unshift(b), a.validator.format.apply(this, c);
            }
          : (arguments.length > 2 &&
              c.constructor != Array &&
              (c = a.makeArray(arguments).slice(1)),
            c.constructor != Array && (c = [c]),
            a.each(c, function (a, c) {
              b = b.replace(new RegExp("\\{" + a + "\\}", "g"), c);
            }),
            b);
      }),
      a.extend(a.validator, {
        defaults: {
          messages: {},
          groups: {},
          rules: {},
          errorClass: "error",
          validClass: "valid",
          errorElement: "label",
          focusInvalid: !0,
          errorContainer: a([]),
          errorLabelContainer: a([]),
          onsubmit: !0,
          ignore: [],
          ignoreTitle: !1,
          onfocusin: function (a) {
            (this.lastActive = a),
              this.settings.focusCleanup &&
                !this.blockFocusCleanup &&
                (this.settings.unhighlight &&
                  this.settings.unhighlight.call(
                    this,
                    a,
                    this.settings.errorClass,
                    this.settings.validClass
                  ),
                this.addWrapper(this.errorsFor(a)).hide());
          },
          onfocusout: function (a) {
            this.checkable(a) ||
              (!(a.name in this.submitted) && this.optional(a)) ||
              this.element(a);
          },
          onkeyup: function (a) {
            (a.name in this.submitted || a == this.lastElement) &&
              this.element(a);
          },
          onclick: function (a) {
            a.name in this.submitted
              ? this.element(a)
              : a.parentNode.name in this.submitted &&
                this.element(a.parentNode);
          },
          highlight: function (b, c, d) {
            "radio" === b.type
              ? this.findByName(b.name).addClass(c).removeClass(d)
              : a(b).addClass(c).removeClass(d);
          },
          unhighlight: function (b, c, d) {
            "radio" === b.type
              ? this.findByName(b.name).removeClass(c).addClass(d)
              : a(b).removeClass(c).addClass(d);
          },
        },
        setDefaults: function (b) {
          a.extend(a.validator.defaults, b);
        },
        messages: {
          required: "This field is required.",
          remote: "Please fix this field.",
          email: "Please enter a valid email address.",
          url: "Please enter a valid URL.",
          date: "Please enter a valid date.",
          dateISO: "Please enter a valid date (ISO).",
          number: "Please enter a valid number.",
          digits: "Please enter only digits.",
          creditcard: "Please enter a valid credit card number.",
          equalTo: "Please enter the same value again.",
          accept: "Please enter a value with a valid extension.",
          maxlength: a.validator.format(
            "Please enter no more than {0} characters."
          ),
          minlength: a.validator.format(
            "Please enter at least {0} characters."
          ),
          rangelength: a.validator.format(
            "Please enter a value between {0} and {1} characters long."
          ),
          range: a.validator.format(
            "Please enter a value between {0} and {1}."
          ),
          max: a.validator.format(
            "Please enter a value less than or equal to {0}."
          ),
          min: a.validator.format(
            "Please enter a value greater than or equal to {0}."
          ),
        },
        autoCreateRanges: !1,
        prototype: {
          init: function () {
            function b(b) {
              var c = a.data(this[0].form, "validator"),
                d = "on" + b.type.replace(/^validate/, "");
              c.settings[d] && c.settings[d].call(c, this[0]);
            }
            (this.labelContainer = a(this.settings.errorLabelContainer)),
              (this.errorContext =
                (this.labelContainer.length && this.labelContainer) ||
                a(this.currentForm)),
              (this.containers = a(this.settings.errorContainer).add(
                this.settings.errorLabelContainer
              )),
              (this.submitted = {}),
              (this.valueCache = {}),
              (this.pendingRequest = 0),
              (this.pending = {}),
              (this.invalid = {}),
              this.reset();
            var c = (this.groups = {});
            a.each(this.settings.groups, function (b, d) {
              a.each(d.split(/\s/), function (a, d) {
                c[d] = b;
              });
            });
            var d = this.settings.rules;
            a.each(d, function (b, c) {
              d[b] = a.validator.normalizeRule(c);
            }),
              a(this.currentForm)
                .validateDelegate(
                  ":text, :password, :file, select, textarea",
                  "focusin focusout keyup",
                  b
                )
                .validateDelegate(
                  ":radio, :checkbox, select, option",
                  "click",
                  b
                ),
              this.settings.invalidHandler &&
                a(this.currentForm).bind(
                  "invalid-form.validate",
                  this.settings.invalidHandler
                );
          },
          form: function () {
            return (
              this.checkForm(),
              a.extend(this.submitted, this.errorMap),
              (this.invalid = a.extend({}, this.errorMap)),
              this.valid() ||
                a(this.currentForm).triggerHandler("invalid-form", [this]),
              this.showErrors(),
              this.valid()
            );
          },
          checkForm: function () {
            this.prepareForm();
            for (
              var a = 0, b = (this.currentElements = this.elements());
              b[a];
              a++
            )
              this.check(b[a]);
            return this.valid();
          },
          element: function (b) {
            (b = this.clean(b)),
              (this.lastElement = b),
              this.prepareElement(b),
              (this.currentElements = a(b));
            var c = this.check(b);
            return (
              c ? delete this.invalid[b.name] : (this.invalid[b.name] = !0),
              this.numberOfInvalids() ||
                (this.toHide = this.toHide.add(this.containers)),
              this.showErrors(),
              c
            );
          },
          showErrors: function (b) {
            if (b) {
              a.extend(this.errorMap, b), (this.errorList = []);
              for (var c in b)
                this.errorList.push({
                  message: b[c],
                  element: this.findByName(c)[0],
                });
              this.successList = a.grep(this.successList, function (a) {
                return !(a.name in b);
              });
            }
            this.settings.showErrors
              ? this.settings.showErrors.call(
                  this,
                  this.errorMap,
                  this.errorList
                )
              : this.defaultShowErrors();
          },
          resetForm: function () {
            a.fn.resetForm && a(this.currentForm).resetForm(),
              (this.submitted = {}),
              this.prepareForm(),
              this.hideErrors(),
              this.elements().removeClass(this.settings.errorClass);
          },
          numberOfInvalids: function () {
            return this.objectLength(this.invalid);
          },
          objectLength: function (a) {
            var b = 0;
            for (var c in a) b++;
            return b;
          },
          hideErrors: function () {
            this.addWrapper(this.toHide).hide();
          },
          valid: function () {
            return 0 == this.size();
          },
          size: function () {
            return this.errorList.length;
          },
          focusInvalid: function () {
            if (this.settings.focusInvalid)
              try {
                a(
                  this.findLastActive() ||
                    (this.errorList.length && this.errorList[0].element) ||
                    []
                )
                  .filter(":visible")
                  .focus()
                  .trigger("focusin");
              } catch (b) {}
          },
          findLastActive: function () {
            var b = this.lastActive;
            return (
              b &&
              1 ==
                a.grep(this.errorList, function (a) {
                  return a.element.name == b.name;
                }).length &&
              b
            );
          },
          elements: function () {
            var b = this,
              c = {};
            return a(this.currentForm)
              .find("input, select, textarea")
              .not(":submit, :reset, :image, [disabled]")
              .not(this.settings.ignore)
              .filter(function () {
                return (
                  !this.name &&
                    b.settings.debug &&
                    window.console &&
                    console.error("%o has no name assigned", this),
                  this.name in c || !b.objectLength(a(this).rules())
                    ? !1
                    : ((c[this.name] = !0), !0)
                );
              });
          },
          clean: function (b) {
            return a(b)[0];
          },
          errors: function () {
            return a(
              this.settings.errorElement + "." + this.settings.errorClass,
              this.errorContext
            );
          },
          reset: function () {
            (this.successList = []),
              (this.errorList = []),
              (this.errorMap = {}),
              (this.toShow = a([])),
              (this.toHide = a([])),
              (this.currentElements = a([]));
          },
          prepareForm: function () {
            this.reset(), (this.toHide = this.errors().add(this.containers));
          },
          prepareElement: function (a) {
            this.reset(), (this.toHide = this.errorsFor(a));
          },
          check: function (b) {
            (b = this.clean(b)),
              this.checkable(b) &&
                (b = this.findByName(b.name).not(this.settings.ignore)[0]);
            var c = a(b).rules(),
              d = !1;
            for (var e in c) {
              var f = { method: e, parameters: c[e] };
              try {
                var g = a.validator.methods[e].call(
                  this,
                  b.value.replace(/\r/g, ""),
                  b,
                  f.parameters
                );
                if ("dependency-mismatch" == g) {
                  d = !0;
                  continue;
                }
                if (((d = !1), "pending" == g))
                  return void (this.toHide = this.toHide.not(
                    this.errorsFor(b)
                  ));
                if (!g) return this.formatAndAdd(b, f), !1;
              } catch (h) {
                throw (
                  (this.settings.debug &&
                    window.console &&
                    console.log(
                      "exception occured when checking element " +
                        b.id +
                        ", check the '" +
                        f.method +
                        "' method",
                      h
                    ),
                  h)
                );
              }
            }
            return d
              ? void 0
              : (this.objectLength(c) && this.successList.push(b), !0);
          },
          customMetaMessage: function (b, c) {
            if (a.metadata) {
              var d = this.settings.meta
                ? a(b).metadata()[this.settings.meta]
                : a(b).metadata();
              return d && d.messages && d.messages[c];
            }
          },
          customMessage: function (a, b) {
            var c = this.settings.messages[a];
            return c && (c.constructor == String ? c : c[b]);
          },
          findDefined: function () {
            for (var a = 0; a < arguments.length; a++)
              if (void 0 !== arguments[a]) return arguments[a];
            return void 0;
          },
          defaultMessage: function (b, c) {
            return this.findDefined(
              this.customMessage(b.name, c),
              this.customMetaMessage(b, c),
              (!this.settings.ignoreTitle && b.title) || void 0,
              a.validator.messages[c],
              "<strong>Warning: No message defined for " + b.name + "</strong>"
            );
          },
          formatAndAdd: function (a, b) {
            var c = this.defaultMessage(a, b.method),
              d = /\$?\{(\d+)\}/g;
            "function" == typeof c
              ? (c = c.call(this, b.parameters, a))
              : d.test(c) &&
                (c = jQuery.format(c.replace(d, "{$1}"), b.parameters)),
              this.errorList.push({ message: c, element: a }),
              (this.errorMap[a.name] = c),
              (this.submitted[a.name] = c);
          },
          addWrapper: function (a) {
            return (
              this.settings.wrapper &&
                (a = a.add(a.parent(this.settings.wrapper))),
              a
            );
          },
          defaultShowErrors: function () {
            for (var a = 0; this.errorList[a]; a++) {
              var b = this.errorList[a];
              this.settings.highlight &&
                this.settings.highlight.call(
                  this,
                  b.element,
                  this.settings.errorClass,
                  this.settings.validClass
                ),
                this.showLabel(b.element, b.message);
            }
            if (
              (this.errorList.length &&
                (this.toShow = this.toShow.add(this.containers)),
              this.settings.success)
            )
              for (var a = 0; this.successList[a]; a++)
                this.showLabel(this.successList[a]);
            if (this.settings.unhighlight)
              for (var a = 0, c = this.validElements(); c[a]; a++)
                this.settings.unhighlight.call(
                  this,
                  c[a],
                  this.settings.errorClass,
                  this.settings.validClass
                );
            (this.toHide = this.toHide.not(this.toShow)),
              this.hideErrors(),
              this.addWrapper(this.toShow).show();
          },
          validElements: function () {
            return this.currentElements.not(this.invalidElements());
          },
          invalidElements: function () {
            return a(this.errorList).map(function () {
              return this.element;
            });
          },
          showLabel: function (b, c) {
            var d = this.errorsFor(b);
            d.length
              ? (d.removeClass().addClass(this.settings.errorClass),
                d.attr("generated") && d.html(c))
              : ((d = a("<" + this.settings.errorElement + "/>")
                  .attr({ for: this.idOrName(b), generated: !0 })
                  .addClass(this.settings.errorClass)
                  .html(c || "")),
                this.settings.wrapper &&
                  (d = d
                    .hide()
                    .show()
                    .wrap("<" + this.settings.wrapper + "/>")
                    .parent()),
                this.labelContainer.append(d).length ||
                  (this.settings.errorPlacement
                    ? this.settings.errorPlacement(d, a(b))
                    : d.insertAfter(b))),
              !c &&
                this.settings.success &&
                (d.text(""),
                "string" == typeof this.settings.success
                  ? d.addClass(this.settings.success)
                  : this.settings.success(d)),
              (this.toShow = this.toShow.add(d));
          },
          errorsFor: function (b) {
            var c = this.idOrName(b);
            return this.errors().filter(function () {
              return a(this).attr("for") == c;
            });
          },
          idOrName: function (a) {
            return (
              this.groups[a.name] ||
              (this.checkable(a) ? a.name : a.id || a.name)
            );
          },
          checkable: function (a) {
            return /radio|checkbox/i.test(a.type);
          },
          findByName: function (b) {
            var c = this.currentForm;
            return a(document.getElementsByName(b)).map(function (a, d) {
              return (d.form == c && d.name == b && d) || null;
            });
          },
          getLength: function (b, c) {
            switch (c.nodeName.toLowerCase()) {
              case "select":
                return a("option:selected", c).length;
              case "input":
                if (this.checkable(c))
                  return this.findByName(c.name).filter(":checked").length;
            }
            return b.length;
          },
          depend: function (a, b) {
            return this.dependTypes[typeof a]
              ? this.dependTypes[typeof a](a, b)
              : !0;
          },
          dependTypes: {
            boolean: function (a, b) {
              return a;
            },
            string: function (b, c) {
              return !!a(b, c.form).length;
            },
            function: function (a, b) {
              return a(b);
            },
          },
          optional: function (b) {
            return (
              !a.validator.methods.required.call(this, a.trim(b.value), b) &&
              "dependency-mismatch"
            );
          },
          startRequest: function (a) {
            this.pending[a.name] ||
              (this.pendingRequest++, (this.pending[a.name] = !0));
          },
          stopRequest: function (b, c) {
            this.pendingRequest--,
              this.pendingRequest < 0 && (this.pendingRequest = 0),
              delete this.pending[b.name],
              c && 0 == this.pendingRequest && this.formSubmitted && this.form()
                ? (a(this.currentForm).submit(), (this.formSubmitted = !1))
                : !c &&
                  0 == this.pendingRequest &&
                  this.formSubmitted &&
                  (a(this.currentForm).triggerHandler("invalid-form", [this]),
                  (this.formSubmitted = !1));
          },
          previousValue: function (b) {
            return (
              a.data(b, "previousValue") ||
              a.data(b, "previousValue", {
                old: null,
                valid: !0,
                message: this.defaultMessage(b, "remote"),
              })
            );
          },
        },
        classRuleSettings: {
          required: { required: !0 },
          email: { email: !0 },
          url: { url: !0 },
          date: { date: !0 },
          dateISO: { dateISO: !0 },
          dateDE: { dateDE: !0 },
          number: { number: !0 },
          numberDE: { numberDE: !0 },
          digits: { digits: !0 },
          creditcard: { creditcard: !0 },
        },
        addClassRules: function (b, c) {
          b.constructor == String
            ? (this.classRuleSettings[b] = c)
            : a.extend(this.classRuleSettings, b);
        },
        classRules: function (b) {
          var c = {},
            d = a(b).attr("class");
          return (
            d &&
              a.each(d.split(" "), function () {
                this in a.validator.classRuleSettings &&
                  a.extend(c, a.validator.classRuleSettings[this]);
              }),
            c
          );
        },
        attributeRules: function (b) {
          var c = {},
            d = a(b);
          for (var e in a.validator.methods) {
            var f = d.attr(e);
            f && (c[e] = f);
          }
          return (
            c.maxlength &&
              /-1|2147483647|524288/.test(c.maxlength) &&
              delete c.maxlength,
            c
          );
        },
        metadataRules: function (b) {
          if (!a.metadata) return {};
          var c = a.data(b.form, "validator").settings.meta;
          return c ? a(b).metadata()[c] : a(b).metadata();
        },
        staticRules: function (b) {
          var c = {},
            d = a.data(b.form, "validator");
          return (
            d.settings.rules &&
              (c = a.validator.normalizeRule(d.settings.rules[b.name]) || {}),
            c
          );
        },
        normalizeRules: function (b, c) {
          return (
            a.each(b, function (d, e) {
              if (e === !1) return void delete b[d];
              if (e.param || e.depends) {
                var f = !0;
                switch (typeof e.depends) {
                  case "string":
                    f = !!a(e.depends, c.form).length;
                    break;
                  case "function":
                    f = e.depends.call(c, c);
                }
                f ? (b[d] = void 0 !== e.param ? e.param : !0) : delete b[d];
              }
            }),
            a.each(b, function (d, e) {
              b[d] = a.isFunction(e) ? e(c) : e;
            }),
            a.each(["minlength", "maxlength", "min", "max"], function () {
              b[this] && (b[this] = Number(b[this]));
            }),
            a.each(["rangelength", "range"], function () {
              b[this] && (b[this] = [Number(b[this][0]), Number(b[this][1])]);
            }),
            a.validator.autoCreateRanges &&
              (b.min &&
                b.max &&
                ((b.range = [b.min, b.max]), delete b.min, delete b.max),
              b.minlength &&
                b.maxlength &&
                ((b.rangelength = [b.minlength, b.maxlength]),
                delete b.minlength,
                delete b.maxlength)),
            b.messages && delete b.messages,
            b
          );
        },
        normalizeRule: function (b) {
          if ("string" == typeof b) {
            var c = {};
            a.each(b.split(/\s/), function () {
              c[this] = !0;
            }),
              (b = c);
          }
          return b;
        },
        addMethod: function (b, c, d) {
          (a.validator.methods[b] = c),
            (a.validator.messages[b] =
              void 0 != d ? d : a.validator.messages[b]),
            c.length < 3 &&
              a.validator.addClassRules(b, a.validator.normalizeRule(b));
        },
        methods: {
          required: function (b, c, d) {
            if (!this.depend(d, c)) return "dependency-mismatch";
            switch (c.nodeName.toLowerCase()) {
              case "select":
                var e = a(c).val();
                return e && e.length > 0;
              case "input":
                if (this.checkable(c)) return this.getLength(b, c) > 0;
              default:
                return a.trim(b).length > 0;
            }
          },
          remote: function (b, c, d) {
            if (this.optional(c)) return "dependency-mismatch";
            var e = this.previousValue(c);
            if (
              (this.settings.messages[c.name] ||
                (this.settings.messages[c.name] = {}),
              (e.originalMessage = this.settings.messages[c.name].remote),
              (this.settings.messages[c.name].remote = e.message),
              (d = ("string" == typeof d && { url: d }) || d),
              this.pending[c.name])
            )
              return "pending";
            if (e.old === b) return e.valid;
            e.old = b;
            var f = this;
            this.startRequest(c);
            var g = {};
            return (
              (g[c.name] = b),
              a.ajax(
                a.extend(
                  !0,
                  {
                    url: d,
                    mode: "abort",
                    port: "validate" + c.name,
                    dataType: "json",
                    data: g,
                    success: function (d) {
                      f.settings.messages[c.name].remote = e.originalMessage;
                      var g = d === !0;
                      if (g) {
                        var h = f.formSubmitted;
                        f.prepareElement(c),
                          (f.formSubmitted = h),
                          f.successList.push(c),
                          f.showErrors();
                      } else {
                        var i = {},
                          j = d || f.defaultMessage(c, "remote");
                        (i[c.name] = e.message = a.isFunction(j) ? j(b) : j),
                          f.showErrors(i);
                      }
                      (e.valid = g), f.stopRequest(c, g);
                    },
                  },
                  d
                )
              ),
              "pending"
            );
          },
          minlength: function (b, c, d) {
            return this.optional(c) || this.getLength(a.trim(b), c) >= d;
          },
          maxlength: function (b, c, d) {
            return this.optional(c) || this.getLength(a.trim(b), c) <= d;
          },
          rangelength: function (b, c, d) {
            var e = this.getLength(a.trim(b), c);
            return this.optional(c) || (e >= d[0] && e <= d[1]);
          },
          min: function (a, b, c) {
            return this.optional(b) || a >= c;
          },
          max: function (a, b, c) {
            return this.optional(b) || c >= a;
          },
          range: function (a, b, c) {
            return this.optional(b) || (a >= c[0] && a <= c[1]);
          },
          email: function (a, b) {
            return (
              this.optional(b) ||
              /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i.test(
                a
              )
            );
          },
          url: function (a, b) {
            return (
              this.optional(b) ||
              /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(
                a
              )
            );
          },
          date: function (a, b) {
            return this.optional(b) || !/Invalid|NaN/.test(new Date(a));
          },
          dateISO: function (a, b) {
            return (
              this.optional(b) || /^\d{4}[\/-]\d{1,2}[\/-]\d{1,2}$/.test(a)
            );
          },
          number: function (a, b) {
            return (
              this.optional(b) ||
              /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/.test(a)
            );
          },
          digits: function (a, b) {
            return this.optional(b) || /^\d+$/.test(a);
          },
          creditcard: function (a, b) {
            if (this.optional(b)) return "dependency-mismatch";
            if (/[^0-9-]+/.test(a)) return !1;
            var c = 0,
              d = 0,
              e = !1;
            a = a.replace(/\D/g, "");
            for (var f = a.length - 1; f >= 0; f--) {
              var g = a.charAt(f),
                d = parseInt(g, 10);
              e && (d *= 2) > 9 && (d -= 9), (c += d), (e = !e);
            }
            return c % 10 == 0;
          },
          accept: function (a, b, c) {
            return (
              (c =
                "string" == typeof c ? c.replace(/,/g, "|") : "png|jpe?g|gif"),
              this.optional(b) || a.match(new RegExp(".(" + c + ")$", "i"))
            );
          },
          equalTo: function (b, c, d) {
            var e = a(d)
              .unbind(".validate-equalTo")
              .bind("blur.validate-equalTo", function () {
                a(c).valid();
              });
            return b == e.val();
          },
        },
      }),
      (a.format = a.validator.format);
  })(jQuery),
  (function (a) {
    var b = {};
    if (a.ajaxPrefilter)
      a.ajaxPrefilter(function (a, c, d) {
        var e = a.port;
        "abort" == a.mode && (b[e] && b[e].abort(), (b[e] = d));
      });
    else {
      var c = a.ajax;
      a.ajax = function (d) {
        var e = ("mode" in d ? d : a.ajaxSettings).mode,
          f = ("port" in d ? d : a.ajaxSettings).port;
        return "abort" == e
          ? (b[f] && b[f].abort(), (b[f] = c.apply(this, arguments)))
          : c.apply(this, arguments);
      };
    }
  })(jQuery),
  (function (a) {
    jQuery.event.special.focusin ||
      jQuery.event.special.focusout ||
      !document.addEventListener ||
      a.each({ focus: "focusin", blur: "focusout" }, function (b, c) {
        function d(b) {
          return (
            (b = a.event.fix(b)), (b.type = c), a.event.handle.call(this, b)
          );
        }
        a.event.special[c] = {
          setup: function () {
            this.addEventListener(b, d, !0);
          },
          teardown: function () {
            this.removeEventListener(b, d, !0);
          },
          handler: function (b) {
            return (
              (arguments[0] = a.event.fix(b)),
              (arguments[0].type = c),
              a.event.handle.apply(this, arguments)
            );
          },
        };
      }),
      a.extend(a.fn, {
        validateDelegate: function (b, c, d) {
          return this.bind(c, function (c) {
            var e = a(c.target);
            return e.is(b) ? d.apply(e, arguments) : void 0;
          });
        },
      });
  })(jQuery);
var QuickSearch = {
  minimum_length: 3,
  search_delay: 125,
  cache: {},
  init: function () {
    $("#search_query").bind("keydown", QuickSearch.on_keydown),
      $("#search_query").bind("keyup", QuickSearch.on_keyup),
      $("#search_query").bind("change", QuickSearch.on_change),
      $("#search_query").blur(QuickSearch.on_blur),
      $("#search_query").attr("autocomplete", "off");
  },
  on_blur: function (a) {
    QuickSearch.item_selected ||
      QuickSearch.over_all ||
      QuickSearch.hide_popup();
  },
  on_keydown: function (a) {
    if (13 != a.keyCode || a.altKey) {
      if (27 == a.keyCode) {
        if (document.getElementById("QuickSearch"))
          try {
            a.preventDefault(), a.stopPropagation();
          } catch (b) {}
        QuickSearch.hide_popup();
      }
    } else {
      if (QuickSearch.selected) {
        try {
          a.preventDefault(), a.stopPropagation();
        } catch (b) {}
        return (window.location = QuickSearch.selected.url), !1;
      }
      QuickSearch.hide_popup();
    }
  },
  on_keyup: function (a) {
    if (
      (QuickSearch.timeout && clearTimeout(QuickSearch.timeout),
      40 == a.keyCode && QuickSearch.results)
    ) {
      QuickSearch.selected &&
        QuickSearch.results.length >= QuickSearch.selected.index + 1 &&
        QuickSearch.highlight_item(QuickSearch.selected.index + 1, !0),
        !QuickSearch.selected &&
          QuickSearch.results.length > 0 &&
          QuickSearch.highlight_item(0, !0);
      try {
        a.preventDefault(), a.stopPropagation();
      } catch (b) {}
      return !1;
    }
    if (38 == a.keyCode && QuickSearch.results) {
      QuickSearch.selected &&
        QuickSearch.selected.index > 0 &&
        QuickSearch.highlight_item(QuickSearch.selected.index - 1, !0);
      try {
        a.preventDefault(), a.stopPropagation();
      } catch (b) {}
    } else if (27 == a.keyCode) QuickSearch.hide_popup();
    else {
      if ($("#search_query").val() == QuickSearch.last_query) return !1;
      (QuickSearch.selected = !1),
        $("#search_query")
          .val()
          .replace(/^\s+|\s+$/g, "").length >= QuickSearch.minimum_length
          ? ((QuickSearch.last_query = $("#search_query")
              .val()
              .replace(/^\s+|\s+$/g, "")),
            QuickSearch.timeout && window.clearTimeout(QuickSearch.timeout),
            (QuickSearch.timeout = window.setTimeout(
              QuickSearch.do_search,
              QuickSearch.search_delay
            )))
          : document.getElementById("QuickSearch") &&
            $("#QuickSearch").remove();
    }
  },
  on_change: function (a) {
    return QuickSearch.on_keydown(a) && QuickSearch.on_keyup(a);
  },
  do_search: function () {
    var a = $("#search_query").val().length + $("#search_query").val();
    QuickSearch.cache[a]
      ? QuickSearch.search_done(QuickSearch.cache[a])
      : $.ajax({
          type: "GET",
          dataType: "xml",
          url:
            "/search.php?action=AjaxSearch&search_query=" +
            encodeURIComponent($("#search_query").val()),
          success: function (a) {
            QuickSearch.search_done(a);
          },
        });
  },
  search_done: function (a) {
    var b = $("#search_query").val().length + $("#search_query").val();
    if (
      ((QuickSearch.cache[b] = a),
      document.getElementById("QuickSearch") && $("#QuickSearch").remove(),
      $("result", a).length > 0)
    ) {
      var c = document.createElement("TABLE");
      (c.className = "QuickSearch"), (c.id = "QuickSearch");
      var d = document.createElement("TBODY");
      c.appendChild(d);
      var e = 0;
      $("result", a).each(function () {
        var a = $($(this).text()),
          b = $(".QuickSearchResultName a", a).attr("href"),
          c = e;
        $(a).attr("id", "QuickSearchResult" + c),
          $(a).bind("mouseover", function () {
            (QuickSearch.item_selected = !0), QuickSearch.highlight_item(c, !1);
          }),
          $(a).bind("mouseup", function () {
            window.location = b;
          }),
          $(a).bind("mouseout", function () {
            (QuickSearch.item_selected = !1), QuickSearch.unhighlight_item(c);
          }),
          $(d).append(a),
          e++;
      });
      var f = $("viewmoreurl", a).size();
      if (f) {
        var g = document.createElement("TR"),
          h = document.createElement("TD");
        (g.className = "QuickSearchAllResults"),
          (g.onmouseover = function () {
            QuickSearch.over_all = !0;
          }),
          (g.onmouseout = function () {
            QuickSearch.over_all = !1;
          }),
          (h.colSpan = 2),
          (h.innerHTML = $("viewmoreurl", a).text()),
          g.appendChild(h),
          d.appendChild(g);
      }
      $("#QuickSearch") && $("#QuickSearch").remove(),
        $("#SearchForm").append(c),
        $(c).show();
    } else document.getElementById("QuickSearch") && $("#QuickSearch").remove();
  },
  hide_popup: function () {
    $("#QuickSearch").remove(), (QuickSearch.selected = null);
  },
  highlight_item: function (a, b) {
    (element = $("#QuickSearchResult" + a)),
      1 == b &&
        (QuickSearch.selected &&
          (QuickSearch.selected.className = "QuickSearchResult"),
        (QuickSearch.selected = document.getElementById(
          "QuickSearchResult" + a
        ))),
      element.addClass("QuickSearchHover");
  },
  unhighlight_item: function (a) {
    (element = $("#QuickSearchResult" + a)),
      element.removeClass("QuickSearchHover");
  },
};
$(document).ready(function () {
  QuickSearch.init();
});
